// Objet global pour gérer l'état des différents modes d'affichage "plein écran"
const autocompleteMode = {
  // ANCIENNES PROPRIÉTÉS COMMENTÉES : liées au mode showBestSellers150
  // showBestSellers150: false,
  // totalBestSellers: null,
  // bestSellersPage: 0,
  // ANCIENNES PROPRIÉTÉS COMMENTÉES : liées au mode showCollectionsAll
  // showCollectionsAll: false,
  // totalCollections: null,
  // collectionsPage: 0,
  showCategory: false,
  selectedCategory: null,
  categoryPage: 0,
  categoryTotal: null,
  showSearchCollectionsAll: false,
  totalSearchCollections: null,
  searchCollectionsPage: 0,
  showCategoryCollectionsAll: false,
  totalCategoryCollections: null,
  categoryCollectionsPage: 0,
  searchResultsPage: 0,
  totalSearchResults: null,
  previousSearchQuery: null
};

// Cache pour les données Shopify (remplace Algolia)
const ALGOLIA_AUTOCOMPLETE_CACHE_DURATION = 5 * 60 * 1000; // 5 minutes
const algoliaAutocompleteCache = {
  trendingProducts: null,
  homepageCollections: null,
  timestamp: null
};

// Variable pour stocker les credentials Algolia (extraites depuis la première requête)
// Utiliser window pour éviter les conflits si les deux fichiers sont chargés sur la même page
if (typeof window.window.algoliaCredentials === 'undefined') {
  window.window.algoliaCredentials = { appId: null, apiKey: null };
}

// Fonction pour extraire le userToken du cookie _ALGOLIA
function getUserTokenFromCookie() {
  try {
    const cookies = document.cookie.split(';');
    const algoliaCookie = cookies.find(c => c.trim().startsWith('_ALGOLIA='));
    if (algoliaCookie) {
      const cookieValue = decodeURIComponent(algoliaCookie.split('=').slice(1).join('='));
      if (cookieValue) {
        // Le cookie _ALGOLIA contient le token directement ou dans un objet JSON
        try {
          const parsed = JSON.parse(cookieValue);
          // Le token peut être dans différentes propriétés selon la version d'Insights
          const token = parsed.userToken || parsed.user || parsed.token || parsed.userID || parsed.user_id;
          if (token) {
            return token;
          }
          // Si pas de token dans l'objet, retourner null
          return null;
        } catch (e) {
          // Si ce n'est pas du JSON, c'est peut-être le token directement (base64 ou autre format)
          // Essayer de décoder en base64
          try {
            const decoded = atob(cookieValue);
            const parsed = JSON.parse(decoded);
            const token = parsed.userToken || parsed.user || parsed.token;
            if (token) {
              return token;
            }
          } catch (e2) {
            // Si ce n'est pas du base64 non plus, retourner la valeur brute
            return cookieValue;
          }
        }
      }
    }
  } catch (e) {
    // Ignorer les erreurs
  }
  return null;
}

// Intercepter les requêtes réseau pour extraire les credentials Algolia
(function() {
  // Intercepter fetch
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = args[0];
    if (typeof url === 'string' && url.includes('algolia') && url.includes('queries')) {
      try {
        const urlObj = new URL(url, window.location.origin);
        const appId = urlObj.searchParams.get('x-algolia-application-id');
        const apiKey = urlObj.searchParams.get('x-algolia-api-key');
        
        if (appId && apiKey && (!window.algoliaCredentials.appId || !window.algoliaCredentials.apiKey)) {
          window.algoliaCredentials.appId = appId;
          window.algoliaCredentials.apiKey = apiKey;
          
          // Initialiser Insights maintenant qu'on a les credentials
          if (window.aa && typeof window.aa === 'function') {
            try {
              window.aa('init', {
                appId: appId,
                apiKey: apiKey,
                useCookie: true
              });
            } catch (e) {
              // Ignorer les erreurs
            }
          }
        }
      } catch (e) {
        // Ignorer les erreurs d'URL
      }
    }
    return originalFetch.apply(this, args);
  };
  
  // Intercepter XMLHttpRequest
  const originalXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    if (typeof url === 'string' && url.includes('algolia') && url.includes('queries')) {
      try {
        const urlObj = new URL(url, window.location.origin);
        const appId = urlObj.searchParams.get('x-algolia-application-id');
        const apiKey = urlObj.searchParams.get('x-algolia-api-key');
        
        if (appId && apiKey && (!window.algoliaCredentials.appId || !window.algoliaCredentials.apiKey)) {
          window.algoliaCredentials.appId = appId;
          window.algoliaCredentials.apiKey = apiKey;
          
          // Initialiser Insights maintenant qu'on a les credentials
          if (window.aa && typeof window.aa === 'function') {
            try {
              window.aa('init', {
                appId: appId,
                apiKey: apiKey,
                useCookie: true
              });
            } catch (e) {
              // Ignorer les erreurs
            }
          }
        }
      } catch (e) {
        // Ignorer les erreurs d'URL
      }
    }
    return originalXHROpen.call(this, method, url, ...rest);
  };
})();

// Fonction pour initialiser Algolia Insights avec useCookie (recommandation Algolia)
function initializeAlgoliaInsightsWithCookie() {
  // Vérifier si Insights est déjà initialisé
  if (!window.aa || typeof window.aa !== 'function') {
    return;
  }
  
  try {
    // Essayer de récupérer le userToken pour vérifier si Insights est initialisé
    const existingToken = window.aa('getUserToken');
    
    // Si on a un token, vérifier le cookie
    if (existingToken) {
      const hasCookie = document.cookie.split(';').some(c => c.trim().startsWith('_ALGOLIA='));
      if (hasCookie) {
        return;
      }
    }
    
    // Si on a déjà les credentials, initialiser directement
    if (window.algoliaCredentials.appId && window.algoliaCredentials.apiKey) {
      window.aa('init', {
        appId: window.algoliaCredentials.appId,
        apiKey: window.algoliaCredentials.apiKey,
        useCookie: true
      });
      return;
    }
    
    // Récupérer les credentials depuis le searchClient du plugin
    const searchClient = window.algoliaShopify?.searchClient;
    if (!searchClient) {
      return;
    }
    
    // Essayer différentes méthodes pour récupérer appId et apiKey
    let appId = searchClient.appId || searchClient._appId;
    let apiKey = searchClient.apiKey || searchClient._apiKey;
    
    // Si pas trouvé directement, essayer via le transporter
    if ((!appId || !apiKey) && searchClient.transporter) {
      const headers = searchClient.transporter.headers || {};
      appId = appId || headers['x-algolia-application-id'];
      apiKey = apiKey || headers['x-algolia-api-key'];
    }
    
    // Si on a les credentials, initialiser et stocker
    if (appId && apiKey) {
      window.algoliaCredentials.appId = appId;
      window.algoliaCredentials.apiKey = apiKey;
      window.aa('init', {
        appId: appId,
        apiKey: apiKey,
        useCookie: true
      });
    }
  } catch (e) {
    // Ignorer les erreurs
  }
}

// Fonction pour synchroniser le userToken généré par Algolia entre tous les searchClients
// Cette fonction est utilisée avant certaines requêtes pour s'assurer que le token est configuré
// Note: La logique principale est dans interceptSearchClientSearch() qui est plus complète
function ensureUserTokenOnSearchClient(searchClient) {
  if (!searchClient) return;
  
  // Récupérer le userToken depuis Algolia Insights
  let userToken = null;
  
  // Méthode 1 : Depuis Insights (prioritaire)
  if (window.aa && typeof window.aa === 'function') {
    try {
      userToken = window.aa('getUserToken');
    } catch (e) {
      // Ignorer si Insights n'est pas disponible
    }
  }
  
  // Méthode 2 : Depuis le cookie si Insights ne retourne rien
  if (!userToken) {
    userToken = getUserTokenFromCookie();
  }
  
  // Si on a un token, le configurer
  if (userToken) {
    if (typeof searchClient.setUserToken === 'function') {
      searchClient.setUserToken(userToken);
    }
    if (window.aa && typeof window.aa === 'function') {
      try {
        window.aa('setUserToken', userToken);
      } catch (e) {}
    }
  }
  
  // Si l'utilisateur est authentifié, définir aussi l'authenticatedUserToken
  const customerId = window.SHOPIFY_CUSTOMER_ID;
  if (customerId && window.aa && typeof window.aa === 'function') {
    // Utiliser l'ID customer directement (sans préfixe "customer-")
    const authenticatedToken = String(customerId);
    try {
      window.aa('setAuthenticatedUserToken', authenticatedToken);
      window.aa('setUserToken', authenticatedToken);
    } catch (e) {}
    if (typeof searchClient.setAuthenticatedUserToken === 'function') {
      searchClient.setAuthenticatedUserToken(authenticatedToken);
    }
  } else if (!customerId && window.aa && typeof window.aa === 'function') {
    // Utilisateur non connecté : setAuthenticatedUserToken(undefined)
    try {
      window.aa('setAuthenticatedUserToken', undefined);
    } catch (e) {}
  }
}

// Fonction pour intercepter searchClient.search() et s'assurer que le userToken est inclus
function interceptSearchClientSearch(searchClient) {
  if (!searchClient || !searchClient.search) {
    return;
  }
  
  const originalSearch = searchClient.search;
  
  searchClient.search = function(requests) {
    // ✅ Extraire les credentials depuis le transporter si pas encore fait
    // Utiliser searchClient au lieu de this car on est dans une closure
    if ((!window.algoliaCredentials.appId || !window.algoliaCredentials.apiKey) && searchClient.transporter) {
      try {
        const headers = searchClient.transporter.headers || searchClient.transporter._headers || {};
        const appId = headers['x-algolia-application-id'] || headers['X-Algolia-Application-Id'];
        const apiKey = headers['x-algolia-api-key'] || headers['X-Algolia-API-Key'];
        
        if (appId && apiKey) {
          window.algoliaCredentials.appId = appId;
          window.algoliaCredentials.apiKey = apiKey;
          
          // Initialiser Insights maintenant qu'on a les credentials
          if (window.aa && typeof window.aa === 'function') {
            try {
              window.aa('init', {
                appId: appId,
                apiKey: apiKey,
                useCookie: true
              });
            } catch (e) {
              // Ignorer les erreurs
            }
          }
        }
      } catch (e) {
        // Ignorer les erreurs
      }
    }
    
    // ✅ LOGIQUE SELON LA DOC ALGOLIA :
    // 1. Si utilisateur connecté : utiliser l'ID customer directement comme authenticatedUserToken ET userToken
    // 2. Si non connecté : utiliser le userToken anonyme depuis le cookie _ALGOLIA
    let userToken = null;
    const customerId = window.SHOPIFY_CUSTOMER_ID;
    
    if (window.aa && typeof window.aa === 'function') {
      // ✅ PRIORITÉ 1 : Si l'utilisateur est connecté
      if (customerId) {
        // Utiliser l'ID customer directement (sans préfixe "customer-")
        const authenticatedToken = String(customerId);
        
        // Selon la doc Algolia : setAuthenticatedUserToken et userToken doivent être identiques
        try {
          window.aa('setAuthenticatedUserToken', authenticatedToken);
          window.aa('setUserToken', authenticatedToken);
          userToken = authenticatedToken;
        } catch (e) {
          // Ignorer les erreurs
          userToken = authenticatedToken;
        }
      } else {
        // ✅ PRIORITÉ 2 : Utilisateur non connecté
        // Selon la doc Algolia : setAuthenticatedUserToken(undefined) quand déconnecté
        try {
          window.aa('setAuthenticatedUserToken', undefined);
        } catch (e) {
          // Ignorer les erreurs
        }
        
        // Récupérer le userToken anonyme depuis le cookie _ALGOLIA
        // Le cookie contient le token directement comme string (format: "anonymous-xxx")
        userToken = getUserTokenFromCookie();
        
        if (userToken) {
          // Configurer ce token sur Insights pour synchronisation
          try {
            window.aa('setUserToken', userToken);
          } catch (e) {
            // Ignorer les erreurs
          }
        }
      }
    } else {
      // Fallback si Insights n'est pas disponible
      if (customerId) {
        userToken = String(customerId);
      } else {
        userToken = getUserTokenFromCookie();
      }
    }
    
    // Si on a un userToken, le configurer sur le searchClient et Insights
    if (userToken) {
      // Configurer sur le searchClient
      if (typeof searchClient.setUserToken === 'function') {
        searchClient.setUserToken(userToken);
      }
      
      // Configurer sur Insights (pour synchronisation)
      if (window.aa && typeof window.aa === 'function') {
        try {
          window.aa('setUserToken', userToken);
        } catch (e) {
          // Ignorer les erreurs
        }
      }
      
      // Ajouter explicitement dans les params de chaque requête
      if (Array.isArray(requests)) {
        requests = requests.map((request) => {
          if (request && request.params) {
            request.params = {
              ...request.params,
              userToken: userToken
            };
          }
          return request;
        });
      }
    }
    
    // Note : Si l'utilisateur est connecté, on utilise déjà customer-{id} comme userToken principal
    // Donc on n'a pas besoin de définir authenticatedUserToken séparément
    
    return originalSearch.call(this, requests);
  };
}


// Fonction pour gérer le changement d'icône de la loupe vers la croix
function toggleSearchIcon() {
  const input = document.querySelector('.aa-Input');
  const submitButton = document.querySelector('.aa-SubmitButton');
  const submitIcon = document.querySelector('.aa-SubmitIcon');
  const clearButton = document.querySelector('.aa-ClearButton');
  const inputWrapperPrefix = document.querySelector('.aa-InputWrapperPrefix');
  const inputWrapperSuffix = document.querySelector('.aa-InputWrapperSuffix');
  
  if (!input || !submitButton || !submitIcon || !clearButton) {
    setTimeout(toggleSearchIcon, 50);
    return;
  }
  
  const hasValue = input.value.trim().length > 0;
  
  if (hasValue) {
    // Cacher complètement le bouton submit (qui contient la loupe)
    submitButton.style.display = 'none';
    
    // Déplacer la croix dans le conteneur de la loupe
    if (inputWrapperPrefix && inputWrapperSuffix) {
      // Supprimer la croix de son conteneur original
      clearButton.remove();
      // L'ajouter dans le conteneur de la loupe
      inputWrapperPrefix.appendChild(clearButton);
    }
    
    // Afficher la croix
    clearButton.style.display = 'block';
    
    // Changer le comportement du bouton pour effacer le contenu
    clearButton.onclick = function(e) {
      e.preventDefault();
      e.stopPropagation();
      input.value = '';
      input.focus();
      toggleSearchIcon(); // Remettre la loupe
      // Déclencher un événement input pour mettre à jour l'autocomplete
      input.dispatchEvent(new Event('input'));
    };
  } else {
    // Remettre le bouton submit (loupe)
    submitButton.style.display = 'block';
    
    // Remettre la croix dans son conteneur original
    if (inputWrapperPrefix && inputWrapperSuffix) {
      clearButton.remove();
      inputWrapperSuffix.appendChild(clearButton);
    }
    
    // Cacher la croix
    clearButton.style.display = 'none';
    
    // Remettre le comportement normal du bouton clear
    clearButton.onclick = null;
  }
}

// Liste des catégories avec leurs identifiants, URLs et images associées
const categories = [
  { id: 'Femme',           url: '/collections/femme',           img: 'https://cdn.shopify.com/s/files/1/0002/7600/4882/files/categorie_femme.jpg?v=1748425647' },
  { id: 'Homme',           url: '/collections/homme',           img: 'https://cdn.shopify.com/s/files/1/0002/7600/4882/files/categorie_homme.jpg?v=1748425647' },
  { id: 'Accessoires',     url: '/collections/accessoires',     img: 'https://cdn.shopify.com/s/files/1/0002/7600/4882/files/categorie_accessoires.jpg?v=1748425832' },
  { id: 'Chaussures',      url: '/collections/chaussures',      img: 'https://cdn.shopify.com/s/files/1/0002/7600/4882/files/categorie_chaussures.jpg?v=1748425647' },
  { id: 'Bien-être',       url: '/collections/bien-etre',       img: 'https://cdn.shopify.com/s/files/1/0002/7600/4882/files/categorie_bien-etre.jpg?v=1748425644' },
  { id: 'Maison',          url: '/collections/maison',          img: 'https://cdn.shopify.com/s/files/1/0002/7600/4882/files/categorie_maison.png?v=1748425831' },
  { id: 'Enfant',          url: '/collections/enfant',          img: 'https://cdn.shopify.com/s/files/1/0002/7600/4882/files/categorie_enfant.png?v=1748425647' },
  { id: 'Abonnement & Cours', url: '/collections/abonnement-cours', img: 'https://cdn.shopify.com/s/files/1/0002/7600/4882/files/categorie-abonnementetcours.png?v=1748425647' },
  { id: 'Voyage',          url: '/collections/voyage',          img: 'https://cdn.shopify.com/s/files/1/0002/7600/4882/files/categorie_voyage.jpg?v=1748425828' }
];
document.addEventListener('click', function(e) {
  if (e.target.closest('.collections-redirect-link')) {
    e.preventDefault();
    localStorage.setItem('showCollectionsView', 'true');
    window.location.href = '/search';
  }
  
  if (e.target.closest('.search-collections-redirect-link')) {
    e.preventDefault();
    localStorage.setItem('showCollectionsView', 'true');
    // Laisser le lien naturel rediriger vers l'URL avec la query
    const link = e.target.closest('.search-collections-redirect-link');
    window.location.href = link.href;
  }
});
// Fonction utilitaire pour forcer le ré-affichage d'Autocomplete : vide le champ, lui redonne le focus, puis déclenche un input ou refresh
function rerenderAutocomplete({ clearQuery = true } = {}) {
  
  const input = document.querySelector('.aa-Input');
  if (!input) return;
  if (clearQuery) {
    input.value = '';
  }
  // input.focus();
  if (window.algoliaShopify?.autocomplete?.refresh) {
    window.algoliaShopify.autocomplete.refresh();
  } else if (window.algoliaShopify?.autocomplete?.start) {
    window.algoliaShopify.autocomplete.start();
  } else {
    input.dispatchEvent(new Event('input'));
  }
}


// ANCIENNE FONCTION COMMENTÉE : Récupère le nombre total de produits dans l'index pour afficher les 150 best sellers
// function fetchTotalBestSellers() {
//   const searchClient = window.algoliaShopify.searchClient;
//   return searchClient.search([{
//     indexName: 'shopify_prod_products',
//     query: '',
//     params: {
//       hitsPerPage: 1
//     }
//   }]).then(({ results }) => {
//     autocompleteMode.totalBestSellers = results[0].nbHits;
//   }).catch(err => {
//     autocompleteMode.totalBestSellers = null;
//   });
// }

function fetchTotalCollections(recherche1Value) {
  const searchClient = window.algoliaShopify.searchClient;
  
  // ✅ S'assurer que le userToken est configuré avant la requête
  if (searchClient) {
    ensureUserTokenOnSearchClient(searchClient);
  }

  // Construction dynamique du bloc params
  const params = { hitsPerPage: 1 };
  if (recherche1Value) {
    params.filters = `meta.custom.Search1:\"${recherche1Value}\"`;
  }

  return searchClient
    .search([{
      indexName: 'shopify_prod_collections',
      query: '',
      params
    }])
    .then(({ results }) => {
      const count = results[0].nbHits;
      if (recherche1Value) {
        // stocke dans totalCategoryCollections si on a filtré
        autocompleteMode.totalCategoryCollections = count;
      } else {
        // comportement inchangé
        autocompleteMode.totalCollections = count;
      }
    })
    .catch(err => {
      if (recherche1Value) {
        autocompleteMode.totalCategoryCollections = null;
      } else {
        autocompleteMode.totalCollections = null;
      }
    });
}


function fetchTotalSearchCollections(query) {
  const searchClient = window.algoliaShopify.searchClient;
  
  // ✅ S'assurer que le userToken est configuré avant la requête
  if (searchClient) {
    ensureUserTokenOnSearchClient(searchClient);
  }
  
  return searchClient.search([{
    indexName: 'shopify_prod_collections',
    query,
    params: { hitsPerPage: 1 }
  }])
  .then(({ results }) => {
    autocompleteMode.totalSearchCollections = results[0].nbHits;
  })
  .catch(() => {
    autocompleteMode.totalSearchCollections = null;
  });
}

// ✅ SUPPRIMÉ : Cette fonction n'est plus nécessaire
// On récupère maintenant nbHits directement depuis onResults() dans searchResultsPlugin
// Cela évite une requête supplémentaire et garantit que le même userToken est utilisé
//
// function fetchTotalSearchResults(query) {
//   const searchClient = window.algoliaShopify.searchClient;
//   
//   if (searchClient) {
//     ensureUserTokenOnSearchClient(searchClient);
//   }
//   
//   return searchClient.search([{
//     indexName: 'shopify_prod_products',
//     query,
//     params: { hitsPerPage: 1 }
//   }])
//   .then(({ results }) => {
//     autocompleteMode.totalSearchResults = results[0].nbHits;
//   })
//   .catch(() => {
//     autocompleteMode.totalSearchResults = null;
//   });
// }
/**
 * noResultsPanel : template qui s'affiche quand il n'y a aucun résultat produit ni collection.
 * On y injecte la query actuelle (state.query) et les deux blocs bestSellers + bestCollections.
 */
function noResultsPanel({ html, state, elements }) {
  return html`
    <div class="aa-Panel__noResult aa-PanelLayout aa-Panel--scrollable">
      <div class="loader-container">
        <div class="loader"></div>
        <p class="loader-text">Chargement…</p>
      </div>
      <div class="aa-PanelSections">
        <div class="aa-PanelSection--fullwidth py-8 text-center">
          ${autocompleteMode.showCategory
          ? html`
              <div class="aa-see-all__product-category--header">
                <back-button class="aa-see-all__best-sellers--back-button">
                  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="14" viewBox="0 0 17 14" fill="none">
                    <path d="M16 7H1M1 7L6.83333 1M1 7L6.83333 13" stroke="#002961" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  catégories > ${autocompleteMode.selectedCategory}
                </back-button>
              </div>
            `
          : ''}

          <!-- 1) Message « Vous cherchez '<query>' » -->
          <div class="aa-Panel__noResult--text">
            <p class="bold aa-Panel__noResult--query">
              Vous cherchez « ${autocompleteMode.showCategory ? autocompleteMode.selectedCategory : state.query} »
            </p>
            <p>
              <span class="bold">Aucun produit ne correspond à votre recherche,</span> mais vous pourriez aimer :
            </p>
          </div>

          <!-- 2) On affiche côte-à-côte bestSellers et bestCollections -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

            <!-- Bloc "Nos best sellers" -->
            <div class="slider-search__best-sellers-results ">
              <div class="aa-SourceHeader flex justify-between items-center mb-4">
                <span class="aa-SourceHeaderTitle">Best sellers</span>
                <see-all-button section="showBestSellers150" class="aa-SourceHeader__see-more">
                  Voir tout
                  <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.233236 11.8245C0.490959 12.0585 0.90777 12.0585 1.16486 11.8245L6.61394 6.86636C6.73592 6.75707 6.83304 6.62553 6.89941 6.47974C6.96578 6.33395 7 6.17695 7 6.0183C7 5.85965 6.96578 5.70266 6.89941 5.55687C6.83304 5.41108 6.73592 5.27954 6.61394 5.17024L1.1254 0.175496C1.00084 0.0638705 0.835881 0.00112939 0.664032 1.50636e-05C0.492182 -0.00109926 0.326326 0.0594968 0.200145 0.169497C0.137637 0.223818 0.0876231 0.28966 0.0531991 0.362944C0.0187752 0.436229 0.000674735 0.515396 1.85384e-05 0.595544C-0.000637658 0.675692 0.0161644 0.755113 0.0493843 0.82889C0.0826042 0.902667 0.131535 0.969229 0.193145 1.02445L5.21651 5.59442C5.27755 5.64907 5.32615 5.71486 5.35937 5.78778C5.39258 5.86071 5.40971 5.93924 5.40971 6.0186C5.40971 6.09796 5.39258 6.1765 5.35937 6.24942C5.32615 6.32234 5.27755 6.38813 5.21651 6.44278L0.233236 10.9768C0.172216 11.0313 0.123623 11.0971 0.090417 11.17C0.0572106 11.2428 0.0400859 11.3213 0.0400859 11.4006C0.0400859 11.4799 0.0572107 11.5584 0.090417 11.6313C0.123623 11.7042 0.172216 11.7699 0.233236 11.8245Z" fill="#002961"/>
                  </svg>
                </see-all-button>
              </div>
              <div class="aa-best-sellers__container">
                ${elements.bestSellers}
              </div>
            </div>

            <!-- Bloc "Nos collections" -->
            <div class="slider-search__collections-results">
              <div class="aa-SourceHeader flex justify-between items-center mb-4">
                <span class="aa-SourceHeaderTitle">Ventes en vedette</span>
                <see-all-button section="showCollectionsAll" class="aa-SourceHeader__see-more">
                  Voir tout
                  <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.233236 11.8245C0.490959 12.0585 0.90777 12.0585 1.16486 11.8245L6.61394 6.86636C6.73592 6.75707 6.83304 6.62553 6.89941 6.47974C6.96578 6.33395 7 6.17695 7 6.0183C7 5.85965 6.96578 5.70266 6.89941 5.55687C6.83304 5.41108 6.73592 5.27954 6.61394 5.17024L1.1254 0.175496C1.00084 0.0638705 0.835881 0.00112939 0.664032 1.50636e-05C0.492182 -0.00109926 0.326326 0.0594968 0.200145 0.169497C0.137637 0.223818 0.0876231 0.28966 0.0531991 0.362944C0.0187752 0.436229 0.000674735 0.515396 1.85384e-05 0.595544C-0.000637658 0.675692 0.0161644 0.755113 0.0493843 0.82889C0.0826042 0.902667 0.131535 0.969229 0.193145 1.02445L5.21651 5.59442C5.27755 5.64907 5.32615 5.71486 5.35937 5.78778C5.39258 5.86071 5.40971 5.93924 5.40971 6.0186C5.40971 6.09796 5.39258 6.1765 5.35937 6.24942C5.32615 6.32234 5.27755 6.38813 5.21651 6.44278L0.233236 10.9768C0.172216 11.0313 0.123623 11.0971 0.090417 11.17C0.0572106 11.2428 0.0400859 11.3213 0.0400859 11.4006C0.0400859 11.4799 0.0572107 11.5584 0.090417 11.6313C0.123623 11.7042 0.172216 11.7699 0.233236 11.8245Z" fill="#002961"/>
                  </svg>
                </see-all-button>
              </div>
              <div class="aa-best-collections__container">
                ${elements.bestCollections}
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  `;
}


function getRecentSearches() {
  return JSON.parse(localStorage.getItem('recentSearches') || '[]');
}


function addRecentSearch(query) {
  if (!query) return;
  // 1) Récupérer les anciennes recherches (sans doublon)
  let list = getRecentSearches().filter(q => q !== query);
  // 2) Préfixer la nouvelle recherche
  list.unshift(query);
  // 3) Ne garder que les 3 plus récentes
  if (list.length > 3) {
    list = list.slice(0, 3);
  }
  // 4) Sauvegarder
  localStorage.setItem('recentSearches', JSON.stringify(list));
}

function removeRecentSearch(query) {
  if (!query) return;
  // 1) on récupère la liste actuelle
  const list = getRecentSearches().filter(q => q !== query);
  // 2) on la remet dans le localStorage
  localStorage.setItem('recentSearches', JSON.stringify(list));
}

function updateMenuAndClose() {
  // 1. Cibler le bouton .button__action.menu et y ajouter 'hidden' s'il n'y est pas déjà
  const menuButton = document.querySelector('.button__action.menu');
  if (menuButton && !menuButton.classList.contains('hidden')) {
    menuButton.classList.add('hidden');
  }

  // 2. Cibler le bouton .aa--close et lui enlever 'hidden' s'il l'a
  const closeButton = document.querySelector('.aa--close');
  if (closeButton && closeButton.classList.contains('hidden')) {
    closeButton.classList.remove('hidden');
  }
}

// Recupère pour un id donné l'URL issue de ton tableau, et en extrait le slug
function getCategorySlugFromId(id) {
  const cat = categories.find(c => c.id === id);
  // ex : cat.url === "/collections/bien-etre"  →  on split sur '/' et on prend le dernier morceau
  return cat ? cat.url.split('/').pop() : '';
}

function scrollToTopOfPanel(smooth = true) {
  const panel = document.querySelector('.aa-Panel');
  if (panel) {
    if (smooth) {
      panel.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      panel.scrollTop = 0;
    }
  }
}


// Intercepter l'initialisation d'Insights pour s'assurer que useCookie est activé
(function() {
  if (!window.aa || typeof window.aa !== 'function') {
    // Si aa n'existe pas encore, on attend qu'il soit chargé
    const checkAA = setInterval(() => {
      if (window.aa && typeof window.aa === 'function') {
        clearInterval(checkAA);
        interceptAAInit();
      }
    }, 100);
    // Timeout après 5 secondes
    setTimeout(() => clearInterval(checkAA), 5000);
  } else {
    interceptAAInit();
  }
  
  function interceptAAInit() {
    // Intercepter les appels à aa('init')
    const originalAA = window.aa;
    
    window.aa = function(command, ...args) {
      if (command === 'init') {
        // S'assurer que useCookie est toujours activé
        const config = args[0] || {};
        if (!config.useCookie) {
          config.useCookie = true;
        }
        return originalAA.call(this, 'init', config);
      }
      return originalAA.call(this, command, ...args);
    };
  }
})();

/**
 * Récupère les produits "trending now" depuis le script JSON injecté par Liquid
 * Plus performant : pas d'appel API, données déjà chargées côté serveur
 */
function fetchTrendingNowProducts() {
  // Vérifier le cache
  if (algoliaAutocompleteCache.trendingProducts && algoliaAutocompleteCache.timestamp && 
      (Date.now() - algoliaAutocompleteCache.timestamp) < ALGOLIA_AUTOCOMPLETE_CACHE_DURATION) {
    return Promise.resolve(algoliaAutocompleteCache.trendingProducts);
  }

  try {
    // Lire les données depuis le script JSON injecté par Liquid
    const scriptElement = document.getElementById('trending-now-products-data');
    
    if (!scriptElement) {
      return Promise.resolve([]);
    }

    const products = JSON.parse(scriptElement.textContent);
    
    // Transformer les images pour avoir les différentes tailles (comme Algolia)
    const formattedProducts = products.map(product => {
      const base = product.product_image;
      if (!base) return product;
      
      const sep = base.includes('?') ? '&' : '?';
      
      return {
        ...product,
        // Ajouter les différentes tailles d'images pour le srcset
        _imageSmall: `${base}${sep}width=400`,
        _imageLarge: `${base}${sep}width=800`,
        _imageXLarge: `${base}${sep}width=1200`
      };
    });

    // Mettre en cache
    algoliaAutocompleteCache.trendingProducts = formattedProducts;
    algoliaAutocompleteCache.timestamp = Date.now();
    
    return Promise.resolve(formattedProducts);
  } catch (error) {
    return Promise.resolve(algoliaAutocompleteCache.trendingProducts || []);
  }
}

/**
 * Récupère les collections "ventes en vedette" depuis le script JSON injecté par Liquid
 * (remplit depuis le metafield shop custom.homepage_collection_handles)
 */
function fetchHomepageCollections() {
  if (algoliaAutocompleteCache.homepageCollections && algoliaAutocompleteCache.timestamp &&
      (Date.now() - algoliaAutocompleteCache.timestamp) < ALGOLIA_AUTOCOMPLETE_CACHE_DURATION) {
    return Promise.resolve(algoliaAutocompleteCache.homepageCollections);
  }

  try {
    const scriptElement = document.getElementById('homepage-collections-data');
    if (!scriptElement) {
      return Promise.resolve([]);
    }

    const collections = JSON.parse(scriptElement.textContent);

    const formattedCollections = (Array.isArray(collections) ? collections : []).map((collection, index) => ({
      handle: collection.handle,
      title: collection.title,
      image: collection.image,
      url: collection.url,
      id: collection.id,
      meta: collection.meta || {
        custom: {
          date_de_fin: '',
          pourcentage_de_reduction: ''
        }
      },
      objectID: collection.id || 'collection-' + (collection.handle || index),
      __autocomplete_queryID: '',
      position: index + 1
    }));

    algoliaAutocompleteCache.homepageCollections = formattedCollections;
    algoliaAutocompleteCache.timestamp = Date.now();

    return Promise.resolve(formattedCollections);
  } catch (error) {
    return Promise.resolve(algoliaAutocompleteCache.homepageCollections || []);
  }
}

// Hook pour initialiser Algolia Autocomplete
document.addEventListener('algolia.hooks.initialize', () => {

  // Fonction pour attendre que les éléments soient disponibles
  function waitForElements() {
    const input = document.querySelector('.aa-Input');
    const submitButton = document.querySelector('.aa-SubmitButton');
    const clearButton = document.querySelector('.aa-ClearButton');
    
    if (!input || !submitButton || !clearButton) {
      setTimeout(waitForElements, 100);
      return;
    }
    
    initializeSearchIconToggle();
  }

  // Initialiser la gestion de l'icône de recherche
  function initializeSearchIconToggle() {
    const input = document.querySelector('.aa-Input');
    const clearButton = document.querySelector('.aa-ClearButton');
    
    if (input) {
      // Écouter les changements d'input
      input.addEventListener('input', toggleSearchIcon);
      input.addEventListener('keyup', toggleSearchIcon);
      input.addEventListener('paste', toggleSearchIcon);
      input.addEventListener('cut', toggleSearchIcon);
      
      // Gérer le clic sur le bouton clear d'Algolia
      if (clearButton) {
        clearButton.addEventListener('click', () => {
          setTimeout(toggleSearchIcon, 10);
        });
      }
      
      // Initialiser l'état de l'icône
      toggleSearchIcon();
    }
  }

  // Démarrer l'attente des éléments
  waitForElements();

    // Avant de configurer les options d'Autocomplete : on définit les plugins à utiliser
    algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', options => {
    // Configuration du debounce pour les plugins
    const DEBOUNCE_DELAY = 500; // Délai de 500ms
    
    const { searchClient } = window.algoliaShopify;
    const { getAlgoliaResults } = window.algoliaShopify.externals;
    
    // ✅ Initialiser Algolia Insights avec useCookie pour persistance du userToken
    initializeAlgoliaInsightsWithCookie();
    
    // ✅ Configurer le userToken et intercepter search() pour garantir qu'il est inclus
    if (searchClient) {
      ensureUserTokenOnSearchClient(searchClient);
      interceptSearchClientSearch(searchClient);
    }

    // Fonction de debounce
    const debounce = (fn, delay) => {
      let timer;
      return (...args) => {
        return new Promise((resolve) => {
          if (timer) {
            clearTimeout(timer);
          }
          timer = setTimeout(() => {
            resolve(fn(...args));
          }, delay);
        });
      };
    };

    // Envelopper les getSources avec debounce
    const wrapGetSourcesWithDebounce = (plugins = [], delay) => {
      plugins
        .filter(({ getSources }) => typeof getSources === 'function')
        .forEach((plugin) => {
          const original = plugin.getSources;
          plugin.getSources = debounce(original, delay);
        });
    };

    // Intercepter aussi getAlgoliaResults si disponible (utilisé par Autocomplete)
    if (getAlgoliaResults) {
        const originalGetAlgoliaResults = getAlgoliaResults;
        
        window.algoliaShopify.externals.getAlgoliaResults = function(...args) {
          const result = debounce(originalGetAlgoliaResults, DEBOUNCE_DELAY).apply(this, args);
          return result;
        };
    }



    const recentSearchesPlugin = {
      name: 'recent-searches-plugin',
      getSources({ query }) {
        if (query !== '') return [];
        const items = getRecentSearches().map(q => ({ query: q }));
        if (!items.length) return [];
        return [{
          sourceId: 'recentSearches',
          getItems() { return Promise.resolve(items); },
          templates: {
            header({ html }) {
              return html`
                <div class="aa-SourceHeader mb-2">
                  <span class="aa-SourceHeaderTitle">Recherches récentes</span>
                  <div class="aa-SourceHeaderLine"/>
                </div>
              `;
            },
            item({ item, html }) {
              return html`
                <recent-search-remove class="aa-suggestion-search-button_container">
                  <suggestion-search-button data-query="${item.query}" class="aa-Item_recentSearches"
                    data-index="query_suggestions_shopify_prod_products"
                    data-object-id="${item.objectID}"
                    data-query-id="${item.__autocomplete_queryID || ''}">
                    ${item.query}
                  </suggestion-search-button>
                  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
                    <path d="M1.13635 1L9.99997 9.86362M1.13635 9.86362L9.99997 1" stroke="#002961" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </recent-search-remove>
              `;
            }
          }
        }];
      }
    };

    // Plugin pour afficher les recherches fréquentes (lorsque le champ est vide)
    // COMMENTÉ : Plugin désactivé mais code conservé pour réactivation future
    /*
    const frequentSearchesPlugin = {
      name: 'frequent-searches-plugin',
      getSources({ query }) {
        if (query !== '') return [];
        return [{
          sourceId: 'frequentSearches',
          getItems() {
            return getAlgoliaResults({
              searchClient,
              queries: [{
                indexName: 'query_suggestions_shopify_prod_products',
                query: '',
                params: { hitsPerPage: 5, clickAnalytics: true }
              }]
            });
          },
          templates: {
            item({ item, html }) {
              return html`<suggestion-search-button data-query="${item.query}" class="aa-Item_frequentSearches rounded-full"
              data-index="query_suggestions_shopify_prod_products"
              data-object-id="${item.objectID}"
              data-query-id="${item.__autocomplete_queryID || ''}"
              >${item.query}</suggestion-search-button>`;
            }
          }
        }];
      }
    };
    */


    // Plugin pour afficher des suggestions de recherche dynamiques (lorsque l'utilisateur tape)
    const suggestionCustomPlugin = {
      name: 'suggestion-custom-plugin',
      getSources({ query }) {
        if (!query) return [];
        return [{
          sourceId: 'suggestionCustom',
          getItems() {
            return getAlgoliaResults({
              searchClient,
              queries: [{
                indexName: 'query_suggestions_shopify_prod_products',
                query,
                params: { hitsPerPage: 4, clickAnalytics: true }
              }]
            });
          },
          templates: {
            header({ html }) {
              return html`
                <div class="aa-suggestionCustom-header aa-SourceHeader suggestion-custom mb-2">
                  <span class="aa-SourceHeaderTitle">Suggestions de recherche</span>
                  <div class="aa-SourceHeaderLine"/>
                </div>`;
            },
            item({ item, html }) {
              return html`
                <suggestion-search-button class="aa-Item_suggestionCustom"
                  data-index="query_suggestions_shopify_prod_products"
                  data-object-id="${item.objectID}"
                  data-query-id="${item.__autocomplete_queryID || ''}"
                  data-position="${item.position || ''}">
                  <svg class="mobile_only" xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
                    <g clip-path="url(#clip0_1463_11724)">
                      <path d="M18.0175 16.5277L14.6545 13.2258C15.9085 11.8454 16.6875 10.0172 16.6875 8.0212C16.6875 3.712 13.1155 0.204941 8.7265 0.204941C4.3375 0.204941 0.765503 3.712 0.765503 8.0212C0.765503 12.3304 4.3375 15.8375 8.7265 15.8375C10.2845 15.8375 11.7285 15.3897 12.9445 14.6436L16.4405 18.076C16.6495 18.2812 16.9345 18.3931 17.2195 18.3931C17.5045 18.3931 17.7895 18.2812 17.9985 18.076C18.4545 17.6469 18.4545 16.9567 18.0175 16.5277ZM2.9885 8.0212C2.9885 4.92454 5.5535 2.38752 8.7265 2.38752C11.8995 2.38752 14.4455 4.92454 14.4455 8.0212C14.4455 11.1178 11.8805 13.6549 8.7265 13.6549C5.5725 13.6549 2.9885 11.1365 2.9885 8.0212Z" fill="#D9D9D9"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_1463_11724">
                        <rect width="19" height="19" fill="white" transform="translate(0.0625)"/>
                      </clipPath>
                    </defs>
                  </svg>
                  ${item.query}
                </suggestion-search-button>`;
            }
          }
        }];
      }
    };

    // Plugin pour rechercher des collections liées à la requête
    const searchCollectionsPlugin = {
      name: 'search-collections-plugin',
      getSources({ query }) {
        if (!query) return [];
        return [{
          sourceId: 'searchCollections',
          getItems() {
            return getAlgoliaResults({
              searchClient,
              queries: [{
                indexName: 'shopify_prod_collections',
                query,
                params: { hitsPerPage: 6, clickAnalytics: true }
              }]
            });
          },
          templates: {
                        
            
            item({ item, html }) {
              // 1) parser la date de fin
              const rawDate  = item.meta.custom.date_de_fin;          // "2025-06-24"
              const endDate  = new Date(rawDate + 'T00:00:00');
              const todayMid = new Date(
                new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate()
              );
              // 2) calcul différence
              const msPerDay = 1000*60*60*24;
              const daysLeft = Math.ceil((endDate - todayMid) / msPerDay);
              // 3) texte
              const saleEnd  = daysLeft > 1
                ? `${daysLeft} jours`
                : daysLeft === 1
                  ? `Il reste 1 jour`
                  : `Aujourd'hui`;
              return html`
                <a href="/collections/${item.handle}" class="aa-ItemIcon rounded-lg overflow-hidden relative desktop_only" style="width:200px;height:120px;"
                  data-index="shopify_prod_collections"
                  data-object-id="${item.objectID}"
                  data-query-id="${item.__autocomplete_queryID || ''}">
                  <img src="${item.image}" alt="${item.title}" class="w-full h-full object-cover" />
                  <div class="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center"></div>
                </a>
                <a href="/collections/${item.handle}" class="aa-collections_card mobile_only"
                  data-index="shopify_prod_collections"
                  data-object-id="${item.objectID}"
                  data-query-id="${item.__autocomplete_queryID || ''}">
                  <div class="aa-collections_img--container rounded-lg overflow-hidden relative">
                    <img src="${item.image}" alt="${item.title}" class="w-full h-full object-cover" />
                    <div class="absolute inset-0 bg-black bg-opacity-30"></div>
                  </div>
                  <div class="aa-collections_infos">
                    <p class="aa-collections_title">${item.title}</p>
                    <p class="aa-collections_pourcentage">${item.meta.custom.pourcentage_de_reduction}</p>
                    <p class="aa-collections_end-date">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
                        <g clip-path="url(#clip0_1463_12198)">
                          <path d="M9.29248 9.04029C7.32032 11.0031 4.13451 11.0031 2.16235 9.04029C0.190187 7.07747 0.190187 3.89733 2.16235 1.94395C4.13451 -0.00943182 7.32032 -0.0188684 9.29248 1.94395C10.0605 2.70831 10.5251 3.65198 10.6958 4.64282L9.08389 3.90677" stroke="#002961" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M5.60413 5.68085L8.1357 6.92648" stroke="#002961" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M5.60413 2.87817V5.68085" stroke="#002961" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M11.5301 3.11407L10.6957 4.64281" stroke="#002961" stroke-miterlimit="10" stroke-linecap="round"/>
                        </g>
                        <defs>
                          <clipPath id="clip0_1463_12198">
                            <rect width="11.7951" height="10.9748" fill="white" transform="translate(0.209106)"/>
                          </clipPath>
                        </defs>
                      </svg>
                      ${saleEnd}
                    </p>
                  </div>
                </a>
                <div class="aa-ItemContentBody"></div>
              `;
            },

          }
        }];
      }
    };

    // Plugin pour afficher les résultats de produits dynamiques
    const searchResultsPlugin = {
      name: 'search-results-plugin',
      getSources({ query }) {
        if (!query) return [];
        
        // ✅ OPTIMISATION : Plus besoin de fetchTotalSearchResults() - on utilise nbHits directement
        
        // NOUVELLE LOGIQUE : Toujours afficher 20 résultats (pas de pagination)
        const hitsPerPage = 20;
        
        return [{
          sourceId: 'searchResults',
          getItems() {
            return getAlgoliaResults({
              searchClient,
              queries: [{
                indexName: 'shopify_prod_products',
                query,
                params: {
                  hitsPerPage: hitsPerPage,
                  page: 0,
                  clickAnalytics: true
                }
              }]
            });
          },
          // 🎯 HOOK POUR CAPTURER LE QUERYID ET nbHits QUAND LES RÉSULTATS ARRIVENT
          onResults({ results }) {
            // Stocker le queryID pour le tracking
            if (results && results[0] && results[0].queryID) {
              storeCurrentSearchQueryID(results[0].queryID);
            }
            
            // ✅ OPTIMISATION : Récupérer nbHits directement depuis les résultats
            // Plus besoin de requête supplémentaire !
            if (results && results[0] && typeof results[0].nbHits !== 'undefined') {
              autocompleteMode.totalSearchResults = results[0].nbHits;
            }
          },
          templates: {
            header({ html }) {
              return html`
                <div class="aa-SourceHeader flex justify-between items-center mb-2">
                  <span class="aa-SourceHeaderTitle">Produits</span>
                  <a href="/search?shopify_prod_products%5Bquery%5D=${encodeURIComponent(query)}" class="aa-SourceHeader__see-more">
                    Voir tout
                    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.233236 11.8245C0.490959 12.0585 0.90777 12.0585 1.16486 11.8245L6.61394 6.86636C6.73592 6.75707 6.83304 6.62553 6.89941 6.47974C6.96578 6.33395 7 6.17695 7 6.0183C7 5.85965 6.96578 5.70266 6.89941 5.55687C6.83304 5.41108 6.73592 5.27954 6.61394 5.17024L1.1254 0.175496C1.00084 0.0638705 0.835881 0.00112939 0.664032 1.50636e-05C0.492182 -0.00109926 0.326326 0.0594968 0.200145 0.169497C0.137637 0.223818 0.0876231 0.28966 0.0531991 0.362944C0.0187752 0.436229 0.000674735 0.515396 1.85384e-05 0.595544C-0.000637658 0.675692 0.0161644 0.755113 0.0493843 0.82889C0.0826042 0.902667 0.131535 0.969229 0.193145 1.02445L5.21651 5.59442C5.27755 5.64907 5.32615 5.71486 5.35937 5.78778C5.39258 5.86071 5.40971 5.93924 5.40971 6.0186C5.40971 6.09796 5.39258 6.1765 5.35937 6.24942C5.32615 6.32234 5.27755 6.38813 5.21651 6.44278L0.233236 10.9768C0.172216 11.0313 0.123623 11.0971 0.090417 11.17C0.0572106 11.2428 0.0400859 11.3213 0.0400859 11.4006C0.0400859 11.4799 0.0572107 11.5584 0.090417 11.6313C0.123623 11.7042 0.172216 11.7699 0.233236 11.8245Z" fill="#002961"/>
                    </svg>
                  </a>
                  <div class="aa-SourceHeaderLine"/>
                </div>
              `;
            },
            item({ item, html }) {
              let small = '', large = '', xLarge = '';
              if (item.product_image) {
              const base = item.product_image;
              const sep  = base.includes('?') ? '&' : '?';
              small = `${base}${sep}width=400`;
              large = `${base}${sep}width=800`;
              xLarge = `${base}${sep}width=1200`;
              }
              const available = item.inventory_available;
              const priceClass = available ? 'aa-ProductPrice' : 'aa-ProductPrice unavailable';
              return html`
                <div class="aa-ProductItem" data-handle="${item.handle}">
                  <a href="/products/${item.handle}" 
                     class="aa-ProductImg"
                     data-index="shopify_prod_products"
                     data-object-id="${item.objectID}"
                     data-query-id="${item.__autocomplete_queryID || ''}"
                     data-position="${item.position || ''}"
                     data-product-id="${item.id || ''}">
                    ${item.product_image ? html
                      `<img src="${small}" srcset=" ${small}    400w, ${large}    800w, ${xLarge} 1200w"
                          sizes="(max-width: 600px) 100vw, 400px"
                          alt="${item.title}"
                          class="aa-ProductImg__img"
                      />
                      `
                      : ''
                    }
                    ${!available ? html
                      `<div class="aa-ProductImg_unavailable-overlay"></div>
                      <div class="aa-ProductImg_unavailable-text">Rupture de stock</div>`
                      : ''
                    }
                    ${available
                      ? html`
                          <icon-add-to-card class="aa-ProductAddToCart">
                            <svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none">
                              <g filter="url(#filter0_d_2482_11147)">
                                <circle cx="21.0909" cy="17.0909" r="17.0909" fill="white"/>
                              </g>
                              <path d="M14.4454 22.902L14.975 12.1476C14.9964 11.7245 15.336 11.3938 15.7493 11.3938H26.4323C26.8456 11.3938 27.1864 11.7257 27.2066 12.1476L27.7362 22.9032C27.7588 23.3567 27.4049 23.7372 26.962 23.7372H15.2196C14.7755 23.7372 14.4228 23.3567 14.4454 22.9032V22.902Z" stroke="#5588CD" stroke-miterlimit="10"/>
                              <path d="M23.9392 13.2927L23.8414 10.2631C23.8197 9.57707 23.532 8.91614 23.0231 8.37963V8.37735C22.0298 7.33401 20.1434 7.33516 19.1541 8.38077C18.648 8.91614 18.363 9.57479 18.3399 10.2586L18.2422 13.2927" stroke="#5588CD" stroke-miterlimit="10"/>
                              <rect x="22.04" y="15.1914" width="6.64646" height="10.4444" fill="white"/>
                              <path d="M26.3135 23.7373V20.4141V23.7373ZM26.3135 20.4141V17.0908V20.4141ZM26.3135 20.4141H29.6367H26.3135ZM26.3135 20.4141H22.9902H26.3135Z" fill="white"/>
                              <path d="M26.3135 23.7373V20.4141M26.3135 20.4141V17.0908M26.3135 20.4141H29.6367M26.3135 20.4141H22.9902H26.3135" stroke="#5688CD" stroke-linecap="round"/>
                              <defs>
                                <filter id="filter0_d_2482_11147" x="0" y="0" width="42.1816" height="42.1819" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                  <feOffset dy="4"/>
                                  <feGaussianBlur stdDeviation="2"/>
                                  <feComposite in2="hardAlpha" operator="out"/>
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2482_11147"/>
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2482_11147" result="shape"/>
                                </filter>
                              </defs>
                            </svg>
                          </icon-add-to-card>
                        `
                      : ''
                    }
                  </a>
                  <a href="/products/${item.handle}" 
                     class="aa-ProductVendor"
                     data-index="shopify_prod_products"
                     data-object-id="${item.objectID}"
                     data-query-id="${item.__autocomplete_queryID || ''}"
                     data-position="${item.position || ''}">${window.cleanVendor(item.vendor)}</a>
                  <a href="/products/${item.handle}" 
                     class="aa-ProductTitle"
                     data-index="shopify_prod_products"
                     data-object-id="${item.objectID}"
                     data-query-id="${item.__autocomplete_queryID || ''}"
                     data-position="${item.position || ''}">${item.title}</a>
                  <div class="flex flex-row items-center">
                    <a href="/products/${item.handle}" 
                       class="${priceClass}"
                       data-index="shopify_prod_products"
                       data-object-id="${item.objectID}"
                       data-query-id="${item.__autocomplete_queryID || ''}"
                       data-position="${item.position || ''}">
                       ${item.variants_min_price < item.variants_max_price ? html`<p class="brand--text starting-at-price text-primary text-[11px] ml-0 md:text-[9px]">${window.themeStrings?.startingAt || 'Dès'} </p>` : ''}
                      ${item.variants_min_price}€
                      ${item.variants_compare_at_price_max != null ? html`<span class="aa-ProductPrice__compare-at-price">${item.variants_compare_at_price_max}€</span>` : ''}
                    </a>
                    <div class="infos--text flex text-grey mr-0 md:mr-0" style="width:100%;">
                      <price-info class="flex price-info_slide">
                        <div class="info-trigger" role="button" aria-label="Infos sur le prix" tabindex="0">
                          <svg width="13" height="13" viewBox="0 0 13 13" xmlns="http://www/w3.org/2000/svg" role="img">
                            <circle cx="6.5" cy="6.5" r="6" stroke="#012961" stroke-width="1" fill="none"/>
                            <rect x="6" y="5" width="1" height="4" fill="#012961"/>
                            <circle cx="6.5" cy="3.5" r="0.5" fill="#012961"/>
                          </svg>
                          <div class="info-popup info-popup-algolia hidden">
                            <div class="close-button">
                              <svg class="close-button-svg" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M1 1L12.0833 12.0833M1 12.0833L12.0833 1" stroke="#002961" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </div>
                            <h3>${window.priceInfoSettings.title}</h3>
                            <p>${window.priceInfoSettings.text_1}</p>
                            <p class="info-popup_subtitle">${window.priceInfoSettings.subtitle_1}</p>
                            <p>${window.priceInfoSettings.text_2}</p>
                            <p class="info-popup_subtitle">${window.priceInfoSettings.subtitle_2}</p>
                            <p>${window.priceInfoSettings.text_3}</p>
                            <p class="info-popup_subtitle">${window.priceInfoSettings.subtitle_3}</p>
                            <p>${window.priceInfoSettings.text_4}</p>
                          </div>
                        </div>
                      </price-info>
                    </div>
                  </div>
                </div>
              `;
            },
            footer({ html, results }) {
              // ✅ OPTIMISATION : Utiliser nbHits directement depuis results (si disponible)
              // Sinon, utiliser la valeur stockée dans onResults()
              const nbHits = (results && results[0] && results[0].nbHits) 
                ? results[0].nbHits 
                : (autocompleteMode.totalSearchResults || 0);
              
              // Afficher le bouton "Voir tous les produits"
              // (Le bouton est toujours affiché, mais on pourrait ajouter une condition si nbHits > hitsPerPage)
              return html`
                <a href="/search?shopify_prod_products%5Bquery%5D=${encodeURIComponent(query)}" class="aa-Button aa-Button--infinite-scroll mt-4 text-center py-2 border border-gray-300 rounded">
                  VOIR TOUS LES PRODUITS
                </a>
              `;
            }
          }
        }];
      }
    };
  

    // Plugin pour afficher les 10 best sellers en page d'accueil
    const customProductsPlugin = {
      name: 'best-sellers-plugin',
      getSources() {
        return [{
          sourceId: 'bestSellers',
          getItems() {
            // ✅ MODIFIÉ : Utiliser fetchTrendingNowProducts() au lieu de getAlgoliaResults
            return fetchTrendingNowProducts().then(products => {
              // Réinitialiser Slick après chargement
              setTimeout(() => {
                if (typeof window.initSlickProducts === 'function') {
                  window.initSlickProducts();
                }
                if (typeof window.initSlickProductsResults === 'function') {
                  window.initSlickProductsResults();
                }
              }, 100);
              return products;
            });
          },
          templates: {
            item({ item, html }) {
              // ✅ Utiliser les nouvelles propriétés d'image si disponibles
              let small = item._imageSmall || '', 
                  large = item._imageLarge || '', 
                  xLarge = item._imageXLarge || '';
              
              // Si pas de propriétés _image*, utiliser product_image comme avant
              if (!small && item.product_image) {
                const base = item.product_image;
                const sep = base.includes('?') ? '&' : '?';
                small = `${base}${sep}width=400`;
                large = `${base}${sep}width=800`;
                xLarge = `${base}${sep}width=1200`;
              }
              const available = item.inventory_available;
              const priceClass = available ? 'aa-ProductPrice' : 'aa-ProductPrice unavailable';
              return html`
                <div class="aa-ProductItem" data-handle="${item.handle}">
                  <a href="/products/${item.handle}" 
                     class="aa-ProductImg"
                     data-index="shopify_prod_products"
                     data-object-id="${item.objectID}"
                     data-query-id="${item.__autocomplete_queryID || ''}"
                     data-position="${item.position || ''}"
                     data-product-id="${item.id || ''}">
                    ${item.product_image ? html
                      `<img src="${small}" srcset=" ${small}    400w, ${large}    800w, ${xLarge} 1200w"
                          sizes="(max-width: 600px) 100vw, 400px"
                          alt="${item.title}"
                          class="aa-ProductImg__img"
                      />
                      `
                      : ''
                    }
                    ${!available ? html
                      `<div class="aa-ProductImg_unavailable-overlay"></div>
                      <div class="aa-ProductImg_unavailable-text">Rupture de stock</div>`
                      : ''
                    }
                    ${available
                      ? html`
                          <icon-add-to-card class="aa-ProductAddToCart">
                            <svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none">
                              <g filter="url(#filter0_d_2482_11147)">
                                <circle cx="21.0909" cy="17.0909" r="17.0909" fill="white"/>
                              </g>
                              <path d="M14.4454 22.902L14.975 12.1476C14.9964 11.7245 15.336 11.3938 15.7493 11.3938H26.4323C26.8456 11.3938 27.1864 11.7257 27.2066 12.1476L27.7362 22.9032C27.7588 23.3567 27.4049 23.7372 26.962 23.7372H15.2196C14.7755 23.7372 14.4228 23.3567 14.4454 22.9032V22.902Z" stroke="#5588CD" stroke-miterlimit="10"/>
                              <path d="M23.9392 13.2927L23.8414 10.2631C23.8197 9.57707 23.532 8.91614 23.0231 8.37963V8.37735C22.0298 7.33401 20.1434 7.33516 19.1541 8.38077C18.648 8.91614 18.363 9.57479 18.3399 10.2586L18.2422 13.2927" stroke="#5588CD" stroke-miterlimit="10"/>
                              <rect x="22.04" y="15.1914" width="6.64646" height="10.4444" fill="white"/>
                              <path d="M26.3135 23.7373V20.4141V23.7373ZM26.3135 20.4141V17.0908V20.4141ZM26.3135 20.4141H29.6367H26.3135ZM26.3135 20.4141H22.9902H26.3135Z" fill="white"/>
                              <path d="M26.3135 23.7373V20.4141M26.3135 20.4141V17.0908M26.3135 20.4141H29.6367M26.3135 20.4141H22.9902H26.3135" stroke="#5688CD" stroke-linecap="round"/>
                              <defs>
                                <filter id="filter0_d_2482_11147" x="0" y="0" width="42.1816" height="42.1819" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                  <feOffset dy="4"/>
                                  <feGaussianBlur stdDeviation="2"/>
                                  <feComposite in2="hardAlpha" operator="out"/>
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2482_11147"/>
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2482_11147" result="shape"/>
                                </filter>
                              </defs>
                            </svg>
                          </icon-add-to-card>
                        `
                      : ''
                    }
                  </a>
                  <a href="/products/${item.handle}" 
                     class="aa-ProductVendor"
                     data-index="shopify_prod_products"
                     data-object-id="${item.objectID}"
                     data-query-id="${item.__autocomplete_queryID || ''}"
                     data-position="${item.position || ''}">${window.cleanVendor(item.vendor)}</a>
                  <a href="/products/${item.handle}" 
                     class="aa-ProductTitle"
                     data-index="shopify_prod_products"
                     data-object-id="${item.objectID}"
                     data-query-id="${item.__autocomplete_queryID || ''}"
                     data-position="${item.position || ''}">${item.title}</a>
                  <div class="flex flex-row items-center">
                    <a href="/products/${item.handle}" 
                       class="${priceClass}"
                       data-index="shopify_prod_products"
                       data-object-id="${item.objectID}"
                       data-query-id="${item.__autocomplete_queryID || ''}"
                       data-position="${item.position || ''}">
                      ${item.variants_min_price < item.variants_max_price ? html`<p class="brand--text starting-at-price text-primary text-[11px] ml-0 md:text-[9px]">${window.themeStrings?.startingAt || 'Dès'} </p>` : ''}
                      ${item.variants_min_price}€
                      ${item.variants_compare_at_price_max != null ? html`<span class="aa-ProductPrice__compare-at-price">${item.variants_compare_at_price_max}€</span>` : ''}
                    </a>
                    <div class="infos--text flex text-grey mr-0 md:mr-0" style="width:100%;">
                      <price-info class="flex price-info_slide">
                        <div class="info-trigger" role="button" aria-label="Infos sur le prix" tabindex="0">
                          <svg width="13" height="13" viewBox="0 0 13 13" xmlns="http://www/w3.org/2000/svg" role="img">
                            <circle cx="6.5" cy="6.5" r="6" stroke="#012961" stroke-width="1" fill="none"/>
                            <rect x="6" y="5" width="1" height="4" fill="#012961"/>
                            <circle cx="6.5" cy="3.5" r="0.5" fill="#012961"/>
                          </svg>
                          <div class="info-popup info-popup-algolia hidden">
                            <div class="close-button">
                              <svg class="close-button-svg" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M1 1L12.0833 12.0833M1 12.0833L12.0833 1" stroke="#002961" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </div>
                            <h3>${window.priceInfoSettings.title}</h3>
                            <p>${window.priceInfoSettings.text_1}</p>
                            <p class="info-popup_subtitle">${window.priceInfoSettings.subtitle_1}</p>
                            <p>${window.priceInfoSettings.text_2}</p>
                            <p class="info-popup_subtitle">${window.priceInfoSettings.subtitle_2}</p>
                            <p>${window.priceInfoSettings.text_3}</p>
                            <p class="info-popup_subtitle">${window.priceInfoSettings.subtitle_3}</p>
                            <p>${window.priceInfoSettings.text_4}</p>
                          </div>
                        </div>
                      </price-info>
                    </div>
                  </div>
                </div>
              `;
            }
          }
        }];
      }
    };

    // Plugin pour afficher les collections mises en avant ("ventes en vedette")
    const customCollectionsPlugin = {
      name: 'best-collections-plugin',
      getSources() {
        return [{
          sourceId: 'bestCollections',
          getItems() {
            return fetchHomepageCollections().then(collections => {
              setTimeout(() => {
                if (typeof window.initSlickCollectionsNoResults === 'function') {
                  window.initSlickCollectionsNoResults();
                }
              }, 100);
              return collections;
            });
          },
          templates: {
            item({ item, html }) {
              return html`
                <a href="/collections/${item.handle}" class="aa-ItemIcon rounded-lg overflow-hidden relative"
                  data-index="shopify_prod_collections"
                  data-object-id="${item.objectID}"
                  data-query-id="${item.__autocomplete_queryID || ''}">
                  <img src="${item.image}" alt="${item.title}" class="w-full h-full object-cover" />
                  <div class="absolute inset-0 bg-black bg-opacity-30"></div>
                </a>
                <div class="aa-ItemContentBody"></div>
              `;
            }
          }
        }];
      }
    };

    // Plugin pour afficher toutes les collections en mode "plein écran", avec pagination
    // const allCollectionsPlugin = {
    //   name: 'all-collections-plugin',
    //   getSources({ state }) {
    //     const hitsPerPage = 20;
    //     const pageIndex = autocompleteMode.collectionsPage || 0;
    //     return [{
    //       sourceId: 'allCollections',
    //       getItems() {
    //         const accumulatedHits = hitsPerPage * (pageIndex + 1);
    //         return getAlgoliaResults({
    //           searchClient,
    //           queries: [{
    //             indexName: 'shopify_prod_collections',
    //             query: '',
    //             params: {
    //               hitsPerPage: accumulatedHits,
    //               page: 0
    //             }
    //           }]
    //         });
    //       },
    //       templates: {
    //         item({ item, html }) {
    //           // 1) parser la date de fin
    //           const rawDate  = item.meta.custom.date_de_fin;          // "2025-06-24"
    //           const endDate  = new Date(rawDate + 'T00:00:00');
    //           const todayMid = new Date(
    //             new Date().getFullYear(),
    //             new Date().getMonth(),
    //             new Date().getDate()
    //           );
    //           // 2) calcul différence
    //           const msPerDay = 1000*60*60*24;
    //           const daysLeft = Math.ceil((endDate - todayMid) / msPerDay);
    //           // 3) texte
    //           const saleEnd  = daysLeft > 1
    //             ? `${daysLeft} jours`
    //             : daysLeft === 1
    //               ? `Il reste 1 jour`
    //               : `Aujourd'hui`;
    //           return html`
    //             <a href="/collections/${item.handle}" class="aa-collections_card">
    //               <div class="aa-collections_img--container rounded-lg overflow-hidden relative">
    //                 <img src="${item.image}" alt="${item.title}" class="w-full h-full object-cover" />
    //                 <div class="absolute inset-0 bg-black bg-opacity-30"></div>
    //               </div>
    //               <div class="aa-collections_infos">
    //                 <p class="aa-collections_title">${item.title}</p>
    //                 <p class="aa-collections_pourcentage">${item.meta.custom.pourcentage_de_reduction}</p>
    //                 <p class="aa-collections_end-date">
    //                   <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
    //                     <g clip-path="url(#clip0_1463_12198)">
    //                       <path d="M9.29248 9.04029C7.32032 11.0031 4.13451 11.0031 2.16235 9.04029C0.190187 7.07747 0.190187 3.89733 2.16235 1.94395C4.13451 -0.00943182 7.32032 -0.0188684 9.29248 1.94395C10.0605 2.70831 10.5251 3.65198 10.6958 4.64282L9.08389 3.90677" stroke="#002961" stroke-linecap="round" stroke-linejoin="round"/>
    //                       <path d="M5.60413 5.68085L8.1357 6.92648" stroke="#002961" stroke-linecap="round" stroke-linejoin="round"/>
    //                       <path d="M5.60413 2.87817V5.68085" stroke="#002961" stroke-linecap="round" stroke-linejoin="round"/>
    //                       <path d="M11.5301 3.11407L10.6957 4.64281" stroke="#002961" stroke-miterlimit="10" stroke-linecap="round"/>
    //                     </g>
    //                     <defs>
    //                       <clipPath id="clip0_1463_12198">
    //                         <rect width="11.7951" height="10.9748" fill="white" transform="translate(0.209106)"/>
    //                       </clipPath>
    //                     </defs>
    //                   </svg>
    //                   ${saleEnd}
    //                 </p>
    //               </div>
    //             </a>
    //           `;
    //         },
    //         footer({ html, results }) {
    //           const nbHits = autocompleteMode.totalCollections || 0;
    //           const pageSize = hitsPerPage;
    //           const pageIndexInner = autocompleteMode.collectionsPage;
    //           const nbPages = Math.ceil(nbHits / pageSize);

    //           if (pageIndexInner + 1 < nbPages) {
    //             return html`
    //               <load-more-button
    //                 section="collections"
    //                 class="aa-Button aa-Button--infinite-scroll mt-4 text-center py-2 border border-gray-300 rounded"
    //               >
    //                 Voir plus de produits
    //               </load-more-button>
    //             `;
    //           }
    //           return null;
    //         }
    //       }
    //     }];
    //   }
    // };

    // ANCIEN PLUGIN COMMENTÉ : Plugin pour afficher les 150 best sellers en plein écran, avec pagination
    // const bestSellers150Plugin = {
    //   name: 'best-sellers-plugin',
    //   getSources() {
    //     const hitsPerPage = 20;
    //     const pageIndex = autocompleteMode.bestSellersPage || 0;
    //     const accumulatedHits = hitsPerPage * (pageIndex + 1);
    //     return [{
    //       sourceId: 'bestSellers150',
    //       getItems() {
    //         return getAlgoliaResults({
    //           searchClient,
    //           queries: [{
    //             indexName: 'shopify_prod_products',
    //             query: '',
    //             params: {
    //               hitsPerPage: accumulatedHits,
    //               page: 0
    //             }
    //           }]
    //         });
    //       },
    //       templates: {
    //         item({ item, html }) {
    //           let small = '', large = '', xLarge = '';
    //           if (item.product_image) {
    //           const base = item.product_image;
    //           const sep  = base.includes('?') ? '&' : '?';
    //           small = `${base}${sep}width=400`;
    //           large = `${base}${sep}width=800`;
    //           xLarge = `${base}${sep}width=1200`;
    //           }
    //           const available = item.inventory_available;
    //           const priceClass = available ? 'aa-ProductPrice' : 'aa-ProductPrice unavailable';
    //           return html`
    //             <div class="aa-ProductItem" data-handle="${item.handle}">
    //               <a href="/products/${item.handle}" class="aa-ProductImg">
    //                 ${item.product_image ? html
    //                   `<img src="${small}" srcset=" ${small}    400w, ${large}    800w, ${xLarge} 1200w"
    //                       sizes="(max-width: 600px) 100vw, 400px"
    //                       alt="${item.title}"
    //                       class="aa-ProductImg__img"
    //                   />
    //                   `
    //                   : ''
    //                 }
    //                 ${!available ? html
    //                   `<div class="aa-ProductImg_unavailable-overlay"></div>
    //                   <div class="aa-ProductImg_unavailable-text">Rupture de stock</div>`
    //                   : ''
    //                 }
    //                 ${available
    //                   ? html`
    //                       <icon-add-to-card class="aa-ProductAddToCart">
    //                         <svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none">
    //                           <g filter="url(#filter0_d_2482_11147)">
    //                             <circle cx="21.0909" cy="17.0909" r="17.0909" fill="white"/>
    //                           </g>
    //                           <path d="M14.4454 22.902L14.975 12.1476C14.9964 11.7245 15.336 11.3938 15.7493 11.3938H26.4323C26.8456 11.3938 27.1864 11.7257 27.2066 12.1476L27.7362 22.9032C27.7588 23.3567 27.4049 23.7372 26.962 23.7372H15.2196C14.7755 23.7372 14.4228 23.3567 14.4454 22.9032V22.902Z" stroke="#5588CD" stroke-miterlimit="10"/>
    //                           <path d="M23.9392 13.2927L23.8414 10.2631C23.8197 9.57707 23.532 8.91614 23.0231 8.37963V8.37735C22.0298 7.33401 20.1434 7.33516 19.1541 8.38077C18.648 8.91614 18.363 9.57479 18.3399 10.2586L18.2422 13.2927" stroke="#5588CD" stroke-miterlimit="10"/>
    //                           <rect x="22.04" y="15.1914" width="6.64646" height="10.4444" fill="white"/>
    //                           <path d="M26.3135 23.7373V20.4141V23.7373ZM26.3135 20.4141V17.0908V20.4141ZM26.3135 20.4141H29.6367H26.3135ZM26.3135 20.4141H22.9902H26.3135Z" fill="white"/>
    //                           <path d="M26.3135 23.7373V20.4141M26.3135 20.4141V17.0908M26.3135 20.4141H29.6367M26.3135 20.4141H22.9902H26.3135" stroke="#5688CD" stroke-linecap="round"/>
    //                           <defs>
    //                             <filter id="filter0_d_2482_11147" x="0" y="0" width="42.1816" height="42.1819" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    //                               <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    //                               <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    //                               <feOffset dy="4"/>
    //                               <feGaussianBlur stdDeviation="2"/>
    //                               <feComposite in2="hardAlpha" operator="out"/>
    //                               <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
    //                               <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2482_11147"/>
    //                               <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2482_11147" result="shape"/>
    //                             </filter>
    //                           </defs>
    //                         </svg>
    //                       </icon-add-to-card>
    //                     `
    //                   : ''
    //                 }
    //               </a>
    //               <a href="/products/${item.handle}" class="aa-ProductVendor">${item.vendor.replace(/^les archives - /i, '')}</a>
    //               <a href="/products/${item.handle}" class="aa-ProductTitle">${item.title}</a>
    //               <div class="flex flex-row items-center">
    //                 <a href="/products/${item.handle}" class="${priceClass}">
    //                   ${item.variants_min_price}€
    //                   ${item.variants_compare_at_price_max != null ? html`<span class="aa-ProductPrice__compare-at-price">${item.variants_compare_at_price_max}€</span>` : ''}
    //                 </a>
    //                 <div class="infos--text flex text-grey mr-0 md:mr-0" style="width:100%;">
    //                   <price-info class="flex price-info_slide">
    //                     <div class="info-trigger" role="button" aria-label="Infos sur le prix" tabindex="0">
    //                       <svg width="13" height="13" viewBox="0 0 13 13" xmlns="http://www/w3.org/2000/svg" role="img">
    //                         <circle cx="6.5" cy="6.5" r="6" stroke="#012961" stroke-width="1" fill="none"/>
    //                         <rect x="6" y="5" width="1" height="4" fill="#012961"/>
    //                         <circle cx="6.5" cy="3.5" r="0.5" fill="#012961"/>
    //                       </svg>
    //                       <div class="info-popup info-popup-algolia hidden">
    //                         <div class="close-button">
    //                           <svg class="close-button-svg" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    //                             <path d="M1 1L12.0833 12.0833M1 12.0833L12.0833 1" stroke="#002961" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    //                           </svg>
    //                         </div>
    //                         <h3>${window.priceInfoSettings.title}</h3>
    //                         <p>${window.priceInfoSettings.text_1}</p>
    //                         <p class="info-popup_subtitle">${window.priceInfoSettings.subtitle_1}</p>
    //                         <p>${window.priceInfoSettings.text_2}</p>
    //                         <p class="info-popup_subtitle">${window.priceInfoSettings.subtitle_2}</p>
    //                         <p>${window.priceInfoSettings.text_3}</p>
    //                         <p class="info-popup_subtitle">${window.priceInfoSettings.subtitle_3}</p>
    //                         <p>${window.priceInfoSettings.text_4}</p>
    //                       </div>
    //                     </div>
    //                   </price-info>
    //                 </div>
    //               </div>
    //             </div>
    //           `;
    //         },
    //         footer({ html, results }) {
    //           const nbHits = autocompleteMode.totalBestSellers || 0;
    //           const pageSize = hitsPerPage;
    //           const pageIndexInner = autocompleteMode.bestSellersPage;
    //           const nbPages = Math.ceil(nbHits / pageSize);

    //           if (pageIndexInner + 1 < nbPages) {
    //             return html`
    //               <load-more-button
    //                 section="bestSellers"
    //                 class="aa-Button aa-Button--infinite-scroll mt-4 text-center py-2 border border-gray-300 rounded"
    //               >
    //                 Voir plus de produits
    //               </load-more-button>
    //             `;
    //           }
    //           return null;
    //         }
    //       }
    //     }];
    //   }
    // };

    // Plugin pour afficher les produits filtrés par catégorie, avec pagination
    const categoryProductsPlugin = {
      name: 'category-products-plugin',
      getSources() {
        const catId = autocompleteMode.selectedCategory;
        if (!catId) return [];
        
        // ANCIENNE LOGIQUE COMMENTÉE : Pagination
        // const hitsPerPage = 30;
        // const pageIndex = autocompleteMode.categoryPage || 0;
        // const accumulatedHits = hitsPerPage * (pageIndex + 1);
        
        // NOUVELLE LOGIQUE : Toujours afficher 30 résultats (pas de pagination)
        const hitsPerPage = 30;
        
        return [{
          sourceId: 'categoryResults',
          getItems() {
            return window.algoliaShopify.externals.getAlgoliaResults({
              searchClient: window.algoliaShopify.searchClient,
              queries: [{
                indexName: 'shopify_prod_products',
                query: '',
                params: {
                  hitsPerPage: hitsPerPage,
                  page: 0,
                  filters: `meta.custom.Search1:"${catId}"`,
                  clickAnalytics: true
                }
              }]
            });
          },
          onResults({ results }) {
            if (results && results[0] && typeof results[0].nbHits === 'number') {
              autocompleteMode.categoryTotal = results[0].nbHits;
            } else {
              autocompleteMode.categoryTotal = null;
            }
          },
          templates: {
            header({ html, }) {
              return html`
                
              `;
            },
            item({ item, html }) {
              
              let small = '', large = '', xLarge ='';
              if (item.product_image) {
              const base = item.product_image;
              const sep  = base.includes('?') ? '&' : '?';
              small = `${base}${sep}width=400`;
              large = `${base}${sep}width=800`;
              xLarge = `${base}${sep}width=1200`;
              }
              const available = item.inventory_available;
              const priceClass = available ? 'aa-ProductPrice' : 'aa-ProductPrice unavailable';
              return html`
                <div class="aa-ProductItem" data-handle="${item.handle}">
                  <a href="/products/${item.handle}" 
                     class="aa-ProductImg"
                     data-index="shopify_prod_products"
                     data-object-id="${item.objectID}"
                     data-query-id="${item.__autocomplete_queryID || ''}"
                     data-position="${item.position || ''}"
                     data-product-id="${item.id || ''}">
                    ${item.product_image ? html
                      `<img src="${small}" srcset=" ${small}    400w, ${large}    800w, ${xLarge} 1200w"
                          sizes="(max-width: 600px) 100vw, 400px"
                          alt="${item.title}"
                          class="aa-ProductImg__img"
                      />
                      `
                      : ''
                    }
                    ${!available ? html
                      `<div class="aa-ProductImg_unavailable-overlay"></div>
                      <div class="aa-ProductImg_unavailable-text">Rupture de stock</div>`
                      : ''
                    }
                    ${available
                      ? html`
                          <icon-add-to-card class="aa-ProductAddToCart">
                            <svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none">
                              <g filter="url(#filter0_d_2482_11147)">
                                <circle cx="21.0909" cy="17.0909" r="17.0909" fill="white"/>
                              </g>
                              <path d="M14.4454 22.902L14.975 12.1476C14.9964 11.7245 15.336 11.3938 15.7493 11.3938H26.4323C26.8456 11.3938 27.1864 11.7257 27.2066 12.1476L27.7362 22.9032C27.7588 23.3567 27.4049 23.7372 26.962 23.7372H15.2196C14.7755 23.7372 14.4228 23.3567 14.4454 22.9032V22.902Z" stroke="#5588CD" stroke-miterlimit="10"/>
                              <path d="M23.9392 13.2927L23.8414 10.2631C23.8197 9.57707 23.532 8.91614 23.0231 8.37963V8.37735C22.0298 7.33401 20.1434 7.33516 19.1541 8.38077C18.648 8.91614 18.363 9.57479 18.3399 10.2586L18.2422 13.2927" stroke="#5588CD" stroke-miterlimit="10"/>
                              <rect x="22.04" y="15.1914" width="6.64646" height="10.4444" fill="white"/>
                              <path d="M26.3135 23.7373V20.4141V23.7373ZM26.3135 20.4141V17.0908V20.4141ZM26.3135 20.4141H29.6367H26.3135ZM26.3135 20.4141H22.9902H26.3135Z" fill="white"/>
                              <path d="M26.3135 23.7373V20.4141M26.3135 20.4141V17.0908M26.3135 20.4141H29.6367M26.3135 20.4141H22.9902H26.3135" stroke="#5688CD" stroke-linecap="round"/>
                              <defs>
                                <filter id="filter0_d_2482_11147" x="0" y="0" width="42.1816" height="42.1819" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                  <feOffset dy="4"/>
                                  <feGaussianBlur stdDeviation="2"/>
                                  <feComposite in2="hardAlpha" operator="out"/>
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
                                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2482_11147"/>
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2482_11147" result="shape"/>
                                </filter>
                              </defs>
                            </svg>
                          </icon-add-to-card>
                        `
                      : ''
                    }
                  </a>
                  <a href="/products/${item.handle}" 
                     class="aa-ProductVendor"
                     data-index="shopify_prod_products"
                     data-object-id="${item.objectID}"
                     data-query-id="${item.__autocomplete_queryID || ''}"
                     data-position="${item.position || ''}">${window.cleanVendor(item.vendor)}</a>
                  <a href="/products/${item.handle}" 
                     class="aa-ProductTitle"
                     data-index="shopify_prod_products"
                     data-object-id="${item.objectID}"
                     data-query-id="${item.__autocomplete_queryID || ''}"
                     data-position="${item.position || ''}">${item.title}</a>
                  <div class="flex flex-row items-center">
                    <a href="/products/${item.handle}" 
                       class="${priceClass}"
                       data-index="shopify_prod_products"
                       data-object-id="${item.objectID}"
                       data-query-id="${item.__autocomplete_queryID || ''}"
                       data-position="${item.position || ''}">
                      ${item.variants_min_price < item.variants_max_price ? html`<p class="brand--text starting-at-price text-primary text-[11px] ml-0 md:text-[9px]">${window.themeStrings?.startingAt || 'Dès'} </p>` : ''}
                      ${item.variants_min_price}€
                      ${item.variants_compare_at_price_max != null ? html`<span class="aa-ProductPrice__compare-at-price">${item.variants_compare_at_price_max}€</span>` : ''}
                    </a>
                    <div class="infos--text flex text-grey mr-0 md:mr-0" style="width:100%;">
                      <price-info class="flex price-info_slide">
                        <div class="info-trigger" role="button" aria-label="Infos sur le prix" tabindex="0">
                          <svg width="13" height="13" viewBox="0 0 13 13" xmlns="http://www/w3.org/2000/svg" role="img">
                            <circle cx="6.5" cy="6.5" r="6" stroke="#012961" stroke-width="1" fill="none"/>
                            <rect x="6" y="5" width="1" height="4" fill="#012961"/>
                            <circle cx="6.5" cy="3.5" r="0.5" fill="#012961"/>
                          </svg>
                          <div class="info-popup info-popup-algolia hidden">
                            <div class="close-button">
                              <svg class="close-button-svg" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M1 1L12.0833 12.0833M1 12.0833L12.0833 1" stroke="#002961" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </div>
                            <h3>${window.priceInfoSettings.title}</h3>
                            <p>${window.priceInfoSettings.text_1}</p>
                            <p class="info-popup_subtitle">${window.priceInfoSettings.subtitle_1}</p>
                            <p>${window.priceInfoSettings.text_2}</p>
                            <p class="info-popup_subtitle">${window.priceInfoSettings.subtitle_2}</p>
                            <p>${window.priceInfoSettings.text_3}</p>
                            <p class="info-popup_subtitle">${window.priceInfoSettings.subtitle_3}</p>
                            <p>${window.priceInfoSettings.text_4}</p>
                          </div>
                        </div>
                      </price-info>
                    </div>
                  </div>
                </div>
              `;
            },
            footer({ html, results }) {
              // ANCIENNE LOGIQUE COMMENTÉE : Calcul des pages pour pagination
              // const nbHits = autocompleteMode.categoryTotal || 0;
              // const pageSize = hitsPerPage;
              // const pageIndexInner = autocompleteMode.categoryPage;
              // const nbPages = Math.ceil(nbHits / pageSize);
              
              // NOUVELLE LOGIQUE : Toujours afficher le bouton (pas de pagination)
              const nbHits = autocompleteMode.categoryTotal || 0;
              const pageSize = hitsPerPage;
              const nbPages = Math.ceil(nbHits / pageSize);

              // Afficher le bouton seulement s'il y a plus de résultats que ce qu'on affiche
         
              const selectedId = autocompleteMode.selectedCategory;
              return html`
                <a href="/search?shopify_prod_products[menu][meta.custom.Search1]=${encodeURIComponent(getCategorySlugFromId(autocompleteMode.selectedCategory))}" class="aa-Button aa-Button--infinite-scroll mt-4  text-center py-2 border border-gray-300 rounded">
                  VOIR TOUS LES PRODUITS
                </a>
              `;
            }
          }
        }];
      }
    };

    
    // const categoryCollectionsPlugin = {
    //   name: 'best-recherche1-collections-plugin',
    //   getSources() {
    //     const selectedId = autocompleteMode.selectedCategory;
    //     if (!selectedId) return []
    //     // On récupère l'objet catégorie pour avoir son URL
    //     const categoryObj = categories.find(cat => cat.id === selectedId);
    //     if (!categoryObj || !categoryObj.url) return [];

    //     // On split l'URL et on prend la dernière partie (ton slug déjà formaté)
    //     const slug = categoryObj.url.split('/').pop();
    //     return [{
    //       sourceId: 'categoryCollections',
    //       getItems() {
    //         return getAlgoliaResults({
    //           searchClient,
    //           queries: [
    //             {
    //               indexName: 'shopify_prod_collections',
    //               query: '',
    //               params: {
    //                 hitsPerPage: 6,
    //                 // On filtre ici sur le metafield recherche1 = true
    //                 filters: `meta.custom.recherche1:"${slug}"`,
    //                 clickAnalytics: true
    //               }
    //             }
    //           ]
    //         });
    //       },
    //       templates: {
    //         header({ html, state }) {
    //           return html`
    //             <div class="aa-SourceHeader flex justify-between items-center mb-4">
    //               <span class="aa-SourceHeaderTitle">Ventes</span>
    //               <!--  activation du mode showSearchCollectionsAll -->
    //               <see-all-button section="showCategoryCollectionsAll" category="${slug}" class="aa-SourceHeader__see-more">
    //                 Voir tout
    //                 <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
    //                   <path fill-rule="evenodd" clip-rule="evenodd" d="M0.233236 11.8245C0.490959 12.0585 0.90777 12.0585 1.16486 11.8245L6.61394 6.86636C6.73592 6.75707 6.83304 6.62553 6.89941 6.47974C6.96578 6.33395 7 6.17695 7 6.0183C7 5.85965 6.96578 5.70266 6.89941 5.55687C6.83304 5.41108 6.73592 5.27954 6.61394 5.17024L1.1254 0.175496C1.00084 0.0638705 0.835881 0.00112939 0.664032 1.50636e-05C0.492182 -0.00109926 0.326326 0.0594968 0.200145 0.169497C0.137637 0.223818 0.0876231 0.28966 0.0531991 0.362944C0.0187752 0.436229 0.000674735 0.515396 1.85384e-05 0.595544C-0.000637658 0.675692 0.0161644 0.755113 0.0493843 0.82889C0.0826042 0.902667 0.131535 0.969229 0.193145 1.02445L5.21651 5.59442C5.27755 5.64907 5.32615 5.71486 5.35937 5.78778C5.39258 5.86071 5.40971 5.93924 5.40971 6.0186C5.40971 6.09796 5.39258 6.1765 5.35937 6.24942C5.32615 6.32234 5.27755 6.38813 5.21651 6.44278L0.233236 10.9768C0.172216 11.0313 0.123623 11.0971 0.090417 11.17C0.0572106 11.2428 0.0400859 11.3213 0.0400859 11.4006C0.0400859 11.4799 0.0572107 11.5584 0.090417 11.6313C0.123623 11.7042 0.172216 11.7699 0.233236 11.8245Z" fill="#002961"/>
    //                 </svg>
    //               </see-all-button> 
                    
    //                 <!-- redirection vers /search avec query et localStorage -->
    //                 <!-- <a href="/search?shopify_prod_products%5Bquery%5D=${encodeURIComponent(state.query)}" class="aa-SourceHeader__see-more search-collections-redirect-link">
    //                   Voir tout
    //                   <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
    //                     <path fill-rule="evenodd" clip-rule="evenodd" d="M0.233236 11.8245C0.490959 12.0585 0.90777 12.0585 1.16486 11.8245L6.61394 6.86636C6.73592 6.75707 6.83304 6.62553 6.89941 6.47974C6.96578 6.33395 7 6.17695 7 6.0183C7 5.85965 6.96578 5.70266 6.89941 5.55687C6.83304 5.41108 6.73592 5.27954 6.61394 5.17024L1.1254 0.175496C1.00084 0.0638705 0.835881 0.00112939 0.664032 1.50636e-05C0.492182 -0.00109926 0.326326 0.0594968 0.200145 0.169497C0.137637 0.223818 0.0876231 0.28966 0.0531991 0.362944C0.0187752 0.436229 0.000674735 0.515396 1.85384e-05 0.595544C-0.000637658 0.675692 0.0161644 0.755113 0.0493843 0.82889C0.0826042 0.902667 0.131535 0.969229 0.193145 1.02445L5.21651 5.59442C5.27755 5.64907 5.32615 5.71486 5.35937 5.78778C5.39258 5.86071 5.40971 5.93924 5.40971 6.0186C5.40971 6.09796 5.39258 6.1765 5.35937 6.24942C5.32615 6.32234 5.27755 6.38813 5.21651 6.44278L0.233236 10.9768C0.172216 11.0313 0.123623 11.0971 0.090417 11.17C0.0572106 11.2428 0.0400859 11.3213 0.0400859 11.4006C0.0400859 11.4799 0.0572107 11.5584 0.090417 11.6313C0.123623 11.7042 0.172216 11.7699 0.233236 11.8245Z" fill="#002961"/>
    //                     </svg>
    //                   </a>-->
    //                 </div>
    //               `;
    //           },
    //         item({ item, html }) {

              

    //           let small = '', large = '', xLarge = '';
    //           if (item.image) {
    //           const base = item.image;
    //           const sep  = base.includes('?') ? '&' : '?';
    //           small = `${base}${sep}width=400`;
    //           large = `${base}${sep}width=800`;
    //           xLarge = `${base}${sep}width=1200`;
    //           }
    //           return html`
    //             <a href="/collections/${item.handle}" class="aa-ItemIcon rounded-lg overflow-hidden relative
    //               data-index="shopify_prod_collections"
    //               data-object-id="${item.objectID}"
    //               data-query-id="${item.__autocomplete_queryID || ''}">
    //               <img
    //                 src="${small}"
    //                 srcset="
    //                     ${small} 400w,
    //                     ${large} 800w,
    //                     ${xLarge} 1200w
    //                 "
    //                 sizes="(max-width: 600px) 100vw, 400px"
    //                 alt="${item.title}"
    //                 class="w-full h-full object-cover"
    //               />
    //               <div class="absolute inset-0 bg-black bg-opacity-30"></div>
    //             </a>
    //             <div class="aa-ItemContentBody"></div>
    //           `;
    //         }
    //       }
    //     }];
    //   }
    // };
    const categoryCollectionsPlugin = {
      name: 'best-recherche1-collections-plugin',
      getSources() {
        const selectedId = autocompleteMode.selectedCategory;
        if (!selectedId) return []
        // On récupère l'objet catégorie pour avoir son URL
        const categoryObj = categories.find(cat => cat.id === selectedId);
        if (!categoryObj || !categoryObj.url) return [];

        // On split l'URL et on prend la dernière partie (ton slug déjà formaté)
        const slug = categoryObj.url.split('/').pop();
        return [{
          sourceId: 'categoryCollections',
          getItems() {
            return getAlgoliaResults({
              searchClient,
              queries: [
                {
                  indexName: 'shopify_prod_collections',
                  query: '',
                  params: {
                    hitsPerPage: 6,
                    // On filtre ici sur le metafield recherche1 = true
                    filters: `meta.custom.Search1:"${slug}"`,
                    clickAnalytics: true
                  }
                }
              ]
            });
          },
          templates: {
            header({ html, state }) {
              return html`
                <div class="aa-SourceHeader flex justify-between items-center mb-4">
                  <span class="aa-SourceHeaderTitle">Ventes</span>
                  <!--  activation du mode showSearchCollectionsAll -->
                  <a href="/search?shopify_prod_products[menu][meta.custom.Search1]=${encodeURIComponent(getCategorySlugFromId(autocompleteMode.selectedCategory))}" class="aa-SourceHeader__see-more search-collections-redirect-link">
                    Voir tout

                    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.233236 11.8245C0.490959 12.0585 0.90777 12.0585 1.16486 11.8245L6.61394 6.86636C6.73592 6.75707 6.83304 6.62553 6.89941 6.47974C6.96578 6.33395 7 6.17695 7 6.0183C7 5.85965 6.96578 5.70266 6.89941 5.55687C6.83304 5.41108 6.73592 5.27954 6.61394 5.17024L1.1254 0.175496C1.00084 0.0638705 0.835881 0.00112939 0.664032 1.50636e-05C0.492182 -0.00109926 0.326326 0.0594968 0.200145 0.169497C0.137637 0.223818 0.0876231 0.28966 0.0531991 0.362944C0.0187752 0.436229 0.000674735 0.515396 1.85384e-05 0.595544C-0.000637658 0.675692 0.0161644 0.755113 0.0493843 0.82889C0.0826042 0.902667 0.131535 0.969229 0.193145 1.02445L5.21651 5.59442C5.27755 5.64907 5.32615 5.71486 5.35937 5.78778C5.39258 5.86071 5.40971 5.93924 5.40971 6.0186C5.40971 6.09796 5.39258 6.1765 5.35937 6.24942C5.32615 6.32234 5.27755 6.38813 5.21651 6.44278L0.233236 10.9768C0.172216 11.0313 0.123623 11.0971 0.090417 11.17C0.0572106 11.2428 0.0400859 11.3213 0.0400859 11.4006C0.0400859 11.4799 0.0572107 11.5584 0.090417 11.6313C0.123623 11.7042 0.172216 11.7699 0.233236 11.8245Z" fill="#002961"/>
                    </svg>
                  </a>
                    
                    <!-- redirection vers /search avec query et localStorage -->
                    <!-- <a href="/search?shopify_prod_products%5Bquery%5D=${encodeURIComponent(state.query)}" class="aa-SourceHeader__see-more search-collections-redirect-link">
                      Voir tout
                      <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.233236 11.8245C0.490959 12.0585 0.90777 12.0585 1.16486 11.8245L6.61394 6.86636C6.73592 6.75707 6.83304 6.62553 6.89941 6.47974C6.96578 6.33395 7 6.17695 7 6.0183C7 5.85965 6.96578 5.70266 6.89941 5.55687C6.83304 5.41108 6.73592 5.27954 6.61394 5.17024L1.1254 0.175496C1.00084 0.0638705 0.835881 0.00112939 0.664032 1.50636e-05C0.492182 -0.00109926 0.326326 0.0594968 0.200145 0.169497C0.137637 0.223818 0.0876231 0.28966 0.0531991 0.362944C0.0187752 0.436229 0.000674735 0.515396 1.85384e-05 0.595544C-0.000637658 0.675692 0.0161644 0.755113 0.0493843 0.82889C0.0826042 0.902667 0.131535 0.969229 0.193145 1.02445L5.21651 5.59442C5.27755 5.64907 5.32615 5.71486 5.35937 5.78778C5.39258 5.86071 5.40971 5.93924 5.40971 6.0186C5.40971 6.09796 5.39258 6.1765 5.35937 6.24942C5.32615 6.32234 5.27755 6.38813 5.21651 6.44278L0.233236 10.9768C0.172216 11.0313 0.123623 11.0971 0.090417 11.17C0.0572106 11.2428 0.0400859 11.3213 0.0400859 11.4006C0.0400859 11.4799 0.0572107 11.5584 0.090417 11.6313C0.123623 11.7042 0.172216 11.7699 0.233236 11.8245Z" fill="#002961"/>
                        </svg>
                      </a>-->
                    </div>
                  `;
              },
            item({ item, html }) {
              
              let small = '', large = '', xLarge = '';
              if (item.image) {
              const base = item.image;
              const sep  = base.includes('?') ? '&' : '?';
              small = `${base}${sep}width=400`;
              large = `${base}${sep}width=800`;
              xLarge = `${base}${sep}width=1200`;
              }
              return html`
                <a href="/collections/${item.handle}" class="aa-ItemIcon rounded-lg overflow-hidden relative"
                  data-index="shopify_prod_collections"
                  data-object-id="${item.objectID}"
                  data-query-id="${item.__autocomplete_queryID || ''}">
                  <img
                    src="${small}"
                    srcset="
                        ${small} 400w,
                        ${large} 800w,
                        ${xLarge} 1200w
                    "
                    sizes="(max-width: 600px) 100vw, 400px"
                    alt="${item.title}"
                    class="w-full h-full object-cover"
                  />
                  <div class="absolute inset-0 bg-black bg-opacity-30"></div>
                </a>
                <a class="aa-ItemContentBody"></div>
              `;
            }
          }
        }];
      }
    };

    const allCategoryCollectionsPlugin = {
      name: 'all-category-collections-plugin',
      getSources({ state }) {
        const hitsPerPage = 20;
        const pageIndex = autocompleteMode.categoryCollectionsPage || 0;
        const selectedId = autocompleteMode.selectedCategory;
        if (!selectedId) return []
        // On récupère l'objet catégorie pour avoir son URL
        const categoryObj = categories.find(cat => cat.id === selectedId);
        if (!categoryObj || !categoryObj.url) return [];

        // On split l'URL et on prend la dernière partie (ton slug déjà formaté)
        const slug = categoryObj.url.split('/').pop();
        return [{
          sourceId: 'allCategoryCollections',
          getItems() {
            const accumulatedHits = hitsPerPage * (pageIndex + 1);
            return getAlgoliaResults({
              searchClient,
              queries: [{
                indexName: 'shopify_prod_collections',
                query: '',
                params: {
                  hitsPerPage: accumulatedHits,
                  page: 0,
                  filters: `meta.custom.Search1:"${slug}"`,
                  clickAnalytics: true
                }
              }]
            });
          },
          templates: {
            item({ item, html }) {
              // 1) parser la date de fin
              const rawDate  = item.meta.custom.date_de_fin;          // "2025-06-24"
              const endDate  = new Date(rawDate + 'T00:00:00');
              const todayMid = new Date(
                new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate()
              );
              // 2) calcul différence
              const msPerDay = 1000*60*60*24;
              const daysLeft = Math.ceil((endDate - todayMid) / msPerDay);
              // 3) texte
              const saleEnd  = daysLeft > 1
                ? `${daysLeft} jours`
                : daysLeft === 1
                  ? `Il reste 1 jour`
                  : `Aujourd'hui`;
              return html`
                <a href="/collections/${item.handle}" class="aa-collections_card
                  data-index="shopify_prod_collections"
                  data-object-id="${item.objectID}"
                  data-query-id="${item.__autocomplete_queryID || ''}">
                  <div class="aa-collections_img--container rounded-lg overflow-hidden relative">
                    <img src="${item.image}" alt="${item.title}" class="w-full h-full object-cover" />
                    <div class="absolute inset-0 bg-black bg-opacity-30"></div>
                  </div>
                  <div class="aa-collections_infos">
                    <p class="aa-collections_title">${item.title}</p>
                    <p class="aa-collections_pourcentage">${item.meta.custom.pourcentage_de_reduction}</p>
                    <p class="aa-collections_end-date">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
                        <g clip-path="url(#clip0_1463_12198)">
                          <path d="M9.29248 9.04029C7.32032 11.0031 4.13451 11.0031 2.16235 9.04029C0.190187 7.07747 0.190187 3.89733 2.16235 1.94395C4.13451 -0.00943182 7.32032 -0.0188684 9.29248 1.94395C10.0605 2.70831 10.5251 3.65198 10.6958 4.64282L9.08389 3.90677" stroke="#002961" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M5.60413 5.68085L8.1357 6.92648" stroke="#002961" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M5.60413 2.87817V5.68085" stroke="#002961" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M11.5301 3.11407L10.6957 4.64281" stroke="#002961" stroke-miterlimit="10" stroke-linecap="round"/>
                        </g>
                        <defs>
                          <clipPath id="clip0_1463_12198">
                            <rect width="11.7951" height="10.9748" fill="white" transform="translate(0.209106)"/>
                          </clipPath>
                        </defs>
                      </svg>
                      ${saleEnd}
                    </p>
                  </div>
                </a>
              `;
            },
            footer({ html, results }) {
              const nbHits = autocompleteMode.totalCategoryCollections || 0;
              const pageSize = hitsPerPage;
              const pageIndexInner = autocompleteMode.categoryCollectionsPage;
              const nbPages = Math.ceil(nbHits / pageSize);

              if (pageIndexInner + 1 < nbPages) {
                return html`
                  <load-more-button
                    section="categoryCollections"
                    class="aa-Button aa-Button--infinite-scroll mt-4 text-center py-2 border border-gray-300 rounded"
                  >
                    Voir plus de produits
                  </load-more-button>
                `;
              }
              return null;
            }
          }
        }];
      }
    };


    // Assemblage de tous les plugins dans un tableau
    const pluginList = [
      recentSearchesPlugin,
      // COMMENTÉ : frequentSearchesPlugin désactivé mais code conservé
      // frequentSearchesPlugin,
      suggestionCustomPlugin,
      searchCollectionsPlugin,
      // ANCIEN PLUGIN COMMENTÉ : searchCollectionsAllPlugin,
      searchResultsPlugin,
      customProductsPlugin,
      customCollectionsPlugin,
      // ANCIEN PLUGIN COMMENTÉ : allCollectionsPlugin,
      // ANCIEN PLUGIN COMMENTÉ : bestSellers150Plugin,
      categoryProductsPlugin,
      categoryCollectionsPlugin,
      allCategoryCollectionsPlugin
    ];

    // Affectation des plugins et configuration du placeholder
    options.plugins = pluginList;
    options.placeholder = "Que recherchez-vous ?";
    options.openOnFocus = true;
    
    // Appliquer le debounce aux plugins APRÈS leur définition
    wrapGetSourcesWithDebounce(options.plugins, DEBOUNCE_DELAY);
    // options.onSubmit = ({ state }) => {
    //   const q = state.query.trim();
    //   if (!q) return;
    //   addRecentSearch(q);
    //   // on redirige vers la page search de Shopify
    //   window.location.href = `/search?q=${encodeURIComponent(q)}`;
    // };
    options.onSubmit = ({ state }) => {
      const q = state.query.trim();
      if (!q) return;
      addRecentSearch(q);
      const idx = options.indexName || 'shopify_prod_products';
      const param = `${idx}[query]`;
      window.location.href = `/search?${encodeURIComponent(param)}=${encodeURIComponent(q)}`;
    };
    return options;
  });

  algoliaShopify.hooks.registerHook(
    'beforeAutocompleteMainTemplate',
    function(_defaultTemplate, { html, state }, elements) {
      // 1) On ne déclenche le no-results que s'il y a une query non vide
      const isEmpty = state.query === '';

      // 2) Protéger state.collections : on s'assure que c'est bien un tableau
      const collectionsState = Array.isArray(state.collections) ? state.collections : [];

      // 3) On cherche l'entrée "searchResults" (produits dynamiques)
      const productsSection = collectionsState.find(
        section => section.source && section.source.sourceId === 'searchResults'
      );
      // 4) On cherche l'entrée "searchCollections" (collections liées)
      const collectionsSection = collectionsState.find(
        section => section.source && section.source.sourceId === 'searchCollections'
      );

      // 5) Récupérer le tableau des hits produits et le tableau des hits collections.
      //    Si l'une ou l'autre n'existe pas (undefined), on met un tableau vide par défaut.
      const productHits    = productsSection    ? productsSection.items    : [];
      const collectionHits = collectionsSection ? collectionsSection.items : [];



      // 6) Détecter "aucun hit produit" et "aucun hit collection"
      const noProductHits    = productHits.length    === 0;
      const noCollectionHits = collectionHits.length === 0;

      // 7) On est en "no results" seulement si la query est non vide ET
      //    qu'il n'y a ni produit, ni collection
      const isSearchDone = state.status !== 'loading';
      const isNoResults = !isEmpty && noProductHits && noCollectionHits && isSearchDone;

      // 8) Construire le HTML "no-results" (déclaré plus bas dans le fichier)
      const noResultsTpl = noResultsPanel({ html, state, elements });
      

      // 9) Vos autres templates "plein écran" (voir – tous les best sellers, toutes les collections, catégories…)
      //    Vous aviez déjà ces blocs : remplacez "… votre template …" par votre contenu exact.
      // ANCIEN TEMPLATE COMMENTÉ : Template plein écran pour les 150 best sellers
      // const seeAllBestSellers = html`
      //   <div class="aa-PanelLayout aa-Panel--scrollable">
      //     <div class="loader-container">
      //       <div class="loader"></div>
      //       <p class="loader-text">Chargement…</p>
      //     </div>
      //     <div class="aa-PanelSections aa-see-all__best-sellers--contaner">
      //       <div class="aa-see-all__best-sellers--header">
      //         <div class="aa-see-all__best-sellers--header-button-total">
      //           <back-button class="aa-see-all__best-sellers--back-button">
      //             <svg  xmlns="http://www.w3.org/2000/svg" width="17" height="14" viewBox="0 0 17 14" fill="none">
      //               <path d="M16 7H1M1 7L6.83333 1M1 7L6.83333 13" stroke="#002961" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      //             </svg>
      //             best sellers
      //           </back-button>
      //           <p class="aa-see-all__best-sellers--total-result">
      //             ${autocompleteMode.totalBestSellers !== null
      //               ? autocompleteMode.totalBestSellers + ' résultats'
      //               : ''}   
      //           </p>
      //         </div>
      //         <a href="/search" class="aa-SourceHeader__see-more">
      //           Voir tout
      //           <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
      //             <path fill-rule="evenodd" clip-rule="evenodd" d="M0.233236 11.8245C0.490959 12.0585 0.90777 12.0585 1.16486 11.8245L6.61394 6.86636C6.73592 6.75707 6.83304 6.62553 6.89941 6.47974C6.96578 6.33395 7 6.17695 7 6.0183C7 5.85965 6.96578 5.70266 6.89941 5.55687C6.83304 5.41108 6.73592 5.27954 6.61394 5.17024L1.1254 0.175496C1.00084 0.0638705 0.835881 0.00112939 0.664032 1.50636e-05C0.492182 -0.00109926 0.326326 0.0594968 0.200145 0.169497C0.137637 0.223818 0.0876231 0.28966 0.0531991 0.362944C0.0187752 0.436229 0.000674735 0.515396 1.85384e-05 0.595544C-0.000637658 0.675692 0.0161644 0.755113 0.0493843 0.82889C0.0826042 0.902667 0.131535 0.969229 0.193145 1.02445L5.21651 5.59442C5.27755 5.64907 5.32615 5.71486 5.35937 5.78778C5.39258 5.86071 5.40971 5.93924 5.40971 6.0186C5.40971 6.09796 5.39258 6.1765 5.35937 6.24942C5.32615 6.32234 5.27755 6.38813 5.21651 6.44278L0.233236 10.9768C0.172216 11.0313 0.123623 11.0971 0.090417 11.17C0.0572106 11.2428 0.0400859 11.3213 0.0400859 11.4006C0.0400859 11.4799 0.0572107 11.5584 0.090417 11.6313C0.123623 11.7042 0.172216 11.7699 0.233236 11.8245Z" fill="#002961"/>
      //           </svg>
      //         </a>
      //       </div>
      //       ${elements.bestSellers150}
      //     </div>
      //   </div>
      // `;

      // Template plein écran pour les produits par catégorie
      const categoryResults = html`
        <div class="aa-PanelLayout aa-Panel--scrollable">
          <div class="loader-container">
            <div class="loader"></div>
            <p class="loader-text">Chargement…</p>
          </div>
          <div class="aa-PanelSections aa-see-all__category--contaner">
            <div class="aa-see-all__product-category--header">
              <back-button class="aa-see-all__best-sellers--back-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="14" viewBox="0 0 17 14" fill="none">
                  <path d="M16 7H1M1 7L6.83333 1M1 7L6.83333 13" stroke="#002961" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                catégories > ${autocompleteMode.selectedCategory}
              </back-button>
            </div>

            <div class="aa-see__collections-category--contaner">
              ${elements.categoryCollections}
            </div>

            <div class="aa-SourceHeader">
              <div class="aa-see-all__product-category--header">
                <div class="aa-see-all__product-category-button-total">
                  <span class="aa-SourceHeaderTitle">Produits</span>
                  <p class="aa-see-all__best-sellers--total-result">
                    ${autocompleteMode.categoryTotal !== null
                      ? autocompleteMode.categoryTotal + ' résultats'
                      : ''}   
                  </p>
                </div>
                <a href="/search?shopify_prod_products[menu][meta.custom.Search1]=${encodeURIComponent(getCategorySlugFromId(autocompleteMode.selectedCategory))}" class="aa-SourceHeader__see-more">
                  Voir tout

                  <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.233236 11.8245C0.490959 12.0585 0.90777 12.0585 1.16486 11.8245L6.61394 6.86636C6.73592 6.75707 6.83304 6.62553 6.89941 6.47974C6.96578 6.33395 7 6.17695 7 6.0183C7 5.85965 6.96578 5.70266 6.89941 5.55687C6.83304 5.41108 6.73592 5.27954 6.61394 5.17024L1.1254 0.175496C1.00084 0.0638705 0.835881 0.00112939 0.664032 1.50636e-05C0.492182 -0.00109926 0.326326 0.0594968 0.200145 0.169497C0.137637 0.223818 0.0876231 0.28966 0.0531991 0.362944C0.0187752 0.436229 0.000674735 0.515396 1.85384e-05 0.595544C-0.000637658 0.675692 0.0161644 0.755113 0.0493843 0.82889C0.0826042 0.902667 0.131535 0.969229 0.193145 1.02445L5.21651 5.59442C5.27755 5.64907 5.32615 5.71486 5.35937 5.78778C5.39258 5.86071 5.40971 5.93924 5.40971 6.0186C5.40971 6.09796 5.39258 6.1765 5.35937 6.24942C5.32615 6.32234 5.27755 6.38813 5.21651 6.44278L0.233236 10.9768C0.172216 11.0313 0.123623 11.0971 0.090417 11.17C0.0572106 11.2428 0.0400859 11.3213 0.0400859 11.4006C0.0400859 11.4799 0.0572107 11.5584 0.090417 11.6313C0.123623 11.7042 0.172216 11.7699 0.233236 11.8245Z" fill="#002961"/>
                  </svg>
                </a>
              </div>
            </div>
            <div class="aa-PanelSections aa-see-all__product-category--contaner">
              ${elements.categoryResults}
            </div>
          </div>
        </div>
      `;

      // ANCIEN TEMPLATE COMMENTÉ : Template plein écran pour toutes les collections
      // const seeAllCollections = html`
      //   <div class="aa-PanelLayout aa-Panel--scrollable">
      //     <div class="loader-container">
      //       <div class="loader"></div>
      //       <p class="loader-text">Chargement…</p>
      //     </div>
      //     <div class="aa-PanelSections aa-see-all__all-collection--contaner">
      //       <div class="aa-see-all__best-sellers--header">
      //         <div class="aa-see-all__best-sellers--header-button-total">
      //           <back-button class="aa-see-all__best-sellers--back-button">
      //             <svg xmlns="http://www.w3.org/2000/svg" width="17" height="14" viewBox="0 0 17 14" fill="none">
      //               <path d="M16 7H1M1 7L6.83333 1M1 7L6.83333 13" stroke="#002961" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      //             </svg>
      //             ventes EN VEDETTE
      //           </back-button>
      //           <p class="aa-see-all__best-sellers--total-result">
      //             ${autocompleteMode.totalCollections !== null
      //               ? autocompleteMode.totalCollections + ' résultats'
      //               : ''}   
      //           </p>
      //         </div>
      //       </div>
      //       ${elements.allCollections}
      //     </div>
      //   </div>
      // `;
      // const seeAllcategoryCollections =  html`
      //   <div class="aa-PanelLayout aa-Panel--scrollable">
      //     <div class="loader-container">
      //       <div class="loader"></div>
      //       <p class="loader-text">Chargement…</p>
      //     </div>
      //     <div class="aa-PanelSections aa-see-all__all-collection--contaner">
      //       <div class="aa-see-all__best-sellers--header">
      //         <div class="aa-see-all__best-sellers--header-button-total">
      //           <back-button section="categoryCollections" cat-id="${autocompleteMode.selectedCategory}" class="aa-see-all__best-sellers--back-button">
      //             <svg xmlns="http://www.w3.org/2000/svg" width="17" height="14" viewBox="0 0 17 14" fill="none">
      //               <path d="M16 7H1M1 7L6.83333 1M1 7L6.83333 13" stroke="#002961" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      //             </svg>
      //             ventes EN VEDETTE
      //           </back-button>
      //           <p class="aa-see-all__best-sellers--total-result">
      //             ${autocompleteMode.totalCategoryCollections !== null
      //               ? autocompleteMode.totalCategoryCollections + ' résultats'
      //               : ''}   
      //           </p>
      //         </div>
      //       </div>
      //       ${elements.allCategoryCollections}
      //     </div>
      //   </div>
      // `;
      const seeAllSearchCollections = html`
        <div class="aa-PanelLayout aa-Panel--scrollable">
          <div class="loader-container">
            <div class="loader"></div>
            <p class="loader-text">Chargement…</p>
          </div>
          <div class="aa-PanelSections aa-see-all__all-search-collection--contaner">
            <p class="aa-see-all__resultat--query" >Résultats pour "${state.query}"</p>
            <div class="aa-see-all__best-sellers--header">
              <back-button class="aa-see-all__best-sellers--back-button">
                <svg  xmlns="http://www.w3.org/2000/svg" width="17" height="14" viewBox="0 0 17 14" fill="none">
                  <path d="M16 7H1M1 7L6.83333 1M1 7L6.83333 13" stroke="#002961" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Ventes
              </back-button>
              <p class="aa-see-all__best-sellers--total-result">
                ${autocompleteMode.totalSearchCollections !== null
                  ? autocompleteMode.totalSearchCollections + ' collection(s)'
                  : ''}
              </p>
            </div>
            ${elements.allSearchCollections}
          </div>
        </div>
      `;
      
      
      const panel = html`
        <div class="aa-PanelLayout aa-Panel--scrollable">
          <div class="loader-container">
            <div class="loader"></div>
            <p class="loader-text">Chargement…</p>
          </div>
          <div class="aa-PanelSections">

            <!-- ➜ COLONNE GAUCHE : recherches fréquentes ou suggestions -->
            <div class="aa-PanelSection--left">
              ${isEmpty
                ? html`
                    ${elements.recentSearches
                      ? html`
                          <div class="aa-SourcerecentSearches">
                            ${elements.recentSearches}
                          </div>
                        `
                      : ''}
                    <!-- COMMENTÉ : Code inconditionnel conservé pour réactivation future du plugin frequentSearches -->
                    <!--
                    <div class="aa-SourcefrequentSearches aa-SourceHeader mb-2">
                      <span class="aa-SourceHeaderTitle">RECHERCHES FRÉQUENTES</span>
                      <div class="aa-SourceHeaderLine"/>
                    </div>
                    <div class="aa-SourcefrequentSearches">
                      ${elements.frequentSearches}
                    </div>
                    -->
                    ${elements.frequentSearches
                      ? html`
                          <div class="aa-SourcefrequentSearches aa-SourceHeader mb-2">
                            <span class="aa-SourceHeaderTitle">RECHERCHES FRÉQUENTES</span>
                            <div class="aa-SourceHeaderLine"/>
                          </div>
                          <div class="aa-SourcefrequentSearches">
                            ${elements.frequentSearches}
                          </div>
                        `
                      : ''}
                  `
                : html`${elements.suggestionCustom}`
              }
            </div>

            <!-- ➜ COLONNE DROITE : si query vide → sliders + catégories / sinon → résultats searchCollections + searchResults -->
            <div class="aa-PanelSection--right">
              ${isEmpty
                ? html`
                    <div class="slider-search__best-sellers">
                      <div class="aa-SourceHeader flex justify-between items-center mb-4">
                        <span class="aa-SourceHeaderTitle">Best sellers</span>
                        <!-- ANCIEN COMPORTEMENT COMMENTÉ : activation du mode showBestSellers150 -->
                        <!-- <see-all-button section="showBestSellers150" class="aa-SourceHeader__see-more">
                          Voir tout
                          <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.233236 11.8245C0.490959 12.0585 0.90777 12.0585 1.16486 11.8245L6.61394 6.86636C6.73592 6.75707 6.83304 6.62553 6.89941 6.47974C6.96578 6.33395 7 6.17695 7 6.0183C7 5.85965 6.96578 5.70266 6.89941 5.55687C6.83304 5.41108 6.73592 5.27954 6.61394 5.17024L1.1254 0.175496C1.00084 0.0638705 0.835881 0.00112939 0.664032 1.50636e-05C0.492182 -0.00109926 0.326326 0.0594968 0.200145 0.169497C0.137637 0.223818 0.0876231 0.28966 0.0531991 0.362944C0.0187752 0.436229 0.000674735 0.515396 1.85384e-05 0.595544C-0.000637658 0.675692 0.0161644 0.755113 0.0493843 0.82889C0.0826042 0.902667 0.131535 0.969229 0.193145 1.02445L5.21651 5.59442C5.27755 5.64907 5.32615 5.71486 5.35937 5.78778C5.39258 5.86071 5.40971 5.93924 5.40971 6.0186C5.40971 6.09796 5.39258 6.1765 5.35937 6.24942C5.32615 6.32234 5.27755 6.38813 5.21651 6.44278L0.233236 10.9768C0.172216 11.0313 0.123623 11.0971 0.090417 11.17C0.0572106 11.2428 0.0400859 11.3213 0.0400859 11.4006C0.0400859 11.4799 0.0572107 11.5584 0.090417 11.6313C0.123623 11.7042 0.172216 11.7699 0.233236 11.8245Z" fill="#002961"/>
                          </svg>
                        </see-all-button> -->
                        
                        <!-- NOUVEAU COMPORTEMENT : redirection directe vers /search -->
                        <a href="/search" class="aa-SourceHeader__see-more">
                          Voir tout
                          <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.233236 11.8245C0.490959 12.0585 0.90777 12.0585 1.16486 11.8245L6.61394 6.86636C6.73592 6.75707 6.83304 6.62553 6.89941 6.47974C6.96578 6.33395 7 6.17695 7 6.0183C7 5.85965 6.96578 5.70266 6.89941 5.55687C6.83304 5.41108 6.73592 5.27954 6.61394 5.17024L1.1254 0.175496C1.00084 0.0638705 0.835881 0.00112939 0.664032 1.50636e-05C0.492182 -0.00109926 0.326326 0.0594968 0.200145 0.169497C0.137637 0.223818 0.0876231 0.28966 0.0531991 0.362944C0.0187752 0.436229 0.000674735 0.515396 1.85384e-05 0.595544C-0.000637658 0.675692 0.0161644 0.755113 0.0493843 0.82889C0.0826042 0.902667 0.131535 0.969229 0.193145 1.02445L5.21651 5.59442C5.27755 5.64907 5.32615 5.71486 5.35937 5.78778C5.39258 5.86071 5.40971 5.93924 5.40971 6.0186C5.40971 6.09796 5.39258 6.1765 5.35937 6.24942C5.32615 6.32234 5.27755 6.38813 5.21651 6.44278L0.233236 10.9768C0.172216 11.0313 0.123623 11.0971 0.090417 11.17C0.0572106 11.2428 0.0400859 11.3213 0.0400859 11.4006C0.0400859 11.4799 0.0572107 11.5584 0.090417 11.6313C0.123623 11.7042 0.172216 11.7699 0.233236 11.8245Z" fill="#002961"/>
                          </svg>
                        </a>
                      </div>
                      ${elements.bestSellers}
                    </div>

                    <div class="slider-search__collections mt-8">
                      <div class="aa-SourceHeader flex justify-between items-center mb-4">
                        <span class="aa-SourceHeaderTitle">Ventes en vedette</span>
                        <!-- ANCIEN COMPORTEMENT COMMENTÉ : activation du mode showCollectionsAll -->
                        <!-- <see-all-button section="showCollectionsAll" class="aa-SourceHeader__see-more">
                          Voir tout
                          <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.233236 11.8245C0.490959 12.0585 0.90777 12.0585 1.16486 11.8245L6.61394 6.86636C6.73592 6.75707 6.83304 6.62553 6.89941 6.47974C6.96578 6.33395 7 6.17695 7 6.0183C7 5.85965 6.96578 5.70266 6.89941 5.55687C6.83304 5.41108 6.73592 5.27954 6.61394 5.17024L1.1254 0.175496C1.00084 0.0638705 0.835881 0.00112939 0.664032 1.50636e-05C0.492182 -0.00109926 0.326326 0.0594968 0.200145 0.169497C0.137637 0.223818 0.0876231 0.28966 0.0531991 0.362944C0.0187752 0.436229 0.000674735 0.515396 1.85384e-05 0.595544C-0.000637658 0.675692 0.0161644 0.755113 0.0493843 0.82889C0.0826042 0.902667 0.131535 0.969229 0.193145 1.02445L5.21651 5.59442C5.27755 5.64907 5.32615 5.71486 5.35937 5.78778C5.39258 5.86071 5.40971 5.93924 5.40971 6.0186C5.40971 6.09796 5.39258 6.1765 5.35937 6.24942C5.32615 6.32234 5.27755 6.38813 5.21651 6.44278L0.233236 10.9768C0.172216 11.0313 0.123623 11.0971 0.090417 11.17C0.0572106 11.2428 0.0400859 11.3213 0.0400859 11.4006C0.0400859 11.4799 0.0572107 11.5584 0.090417 11.6313C0.123623 11.7042 0.172216 11.7699 0.233236 11.8245Z" fill="#002961"/>
                          </svg>
                        </see-all-button> -->
                        
                        <!-- NOUVEAU COMPORTEMENT : redirection vers /search avec sessionStorage pour afficher les collections -->
                        <a href="/search" class="aa-SourceHeader__see-more collections-redirect-link" data-redirect="collections">
                          Voir tout
                          <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.233236 11.8245C0.490959 12.0585 0.90777 12.0585 1.16486 11.8245L6.61394 6.86636C6.73592 6.75707 6.83304 6.62553 6.89941 6.47974C6.96578 6.33395 7 6.17695 7 6.0183C7 5.85965 6.96578 5.70266 6.89941 5.55687C6.83304 5.41108 6.73592 5.27954 6.61394 5.17024L1.1254 0.175496C1.00084 0.0638705 0.835881 0.00112939 0.664032 1.50636e-05C0.492182 -0.00109926 0.326326 0.0594968 0.200145 0.169497C0.137637 0.223818 0.0876231 0.28966 0.0531991 0.362944C0.0187752 0.436229 0.000674735 0.515396 1.85384e-05 0.595544C-0.000637658 0.675692 0.0161644 0.755113 0.0493843 0.82889C0.0826042 0.902667 0.131535 0.969229 0.193145 1.02445L5.21651 5.59442C5.27755 5.64907 5.32615 5.71486 5.35937 5.78778C5.39258 5.86071 5.40971 5.93924 5.40971 6.0186C5.40971 6.09796 5.39258 6.1765 5.35937 6.24942C5.32615 6.32234 5.27755 6.38813 5.21651 6.44278L0.233236 10.9768C0.172216 11.0313 0.123623 11.0971 0.090417 11.17C0.0572106 11.2428 0.0400859 11.3213 0.0400859 11.4006C0.0400859 11.4799 0.0572107 11.5584 0.090417 11.6313C0.123623 11.7042 0.172216 11.7699 0.233236 11.8245Z" fill="#002961"/>
                          </svg>
                        </a>
                      </div>
                      ${elements.bestCollections}
                    </div>

                    <div class="mt-8 category__container">
                      <div class="aa-SourceHeader mb-4">
                        <span class="aa-SourceHeaderTitle">RECHERCHE PAR CATÉGORIES</span>
                      </div>
                      <div class="category__grid">
                        ${categories.map(cat => {
                          let small = '', large = '', xLarge = '';
                          if (cat.img) {
                            const base = cat.img;
                            const sep  = base.includes('?') ? '&' : '?';
                            small = `${base}${sep}width=400`;
                            large = `${base}${sep}width=800`;
                            xLarge = `${base}${sep}width=1200`;
                          }
                          return html`
                            <category-card 
                              cat-id="${cat.id}" 
                              class="category-card flex items-center bg-secondary rounded-lg overflow-hidden"
                            >
                              <div class="category-search__img-title relative">
                                <!-- Remplacement de l'ancienne balise img par la nouvelle -->
                                <img
                                  src="${small}"
                                  srcset="
                                    ${small} 400w,
                                    ${large} 800w,
                                    ${xLarge} 1200w
                                  "
                                  sizes="(max-width: 600px) 100vw, 400px"
                                  alt="${cat.id}"
                                  class="aa-ProductImg__img object-cover category-search__img"
                                />
                                <span class="category-search__title">${cat.id}</span>
                              </div>
                              <div class="arrow--right bg-secondary rounded-full w-[26px] h-[26px] md:h-[30px] md:w-[30px] cursor-pointer">
                                <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
                                  <circle cx="14.5" cy="14.5" r="14" fill="white"/>
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7332 20.3245C11.991 20.5585 12.4078 20.5585 12.6649 20.3245L18.1139 15.3664C18.2359 15.2571 18.333 15.1255 18.3994 14.9797C18.4658 14.8339 18.5 14.677 18.5 14.5183C18.5 14.3597 18.4658 14.2027 18.3994 14.0569C18.333 13.9111 18.2359 13.7795 18.1139 13.6702L12.6254 8.6755C12.5008 8.56387 12.3359 8.50113 12.164 8.50002C11.9922 8.4989 11.8263 8.5595 11.7001 8.6695C11.6376 8.72382 11.5876 8.78966 11.5532 8.86294C11.5188 8.93623 11.5007 9.0154 11.5 9.09554C11.4994 9.17569 11.5162 9.25511 11.5494 9.32889C11.5826 9.40267 11.6315 9.46923 11.6931 9.52445L16.7165 14.0944C16.7775 14.1491 16.8262 14.2149 16.8594 14.2878C16.8926 14.3607 16.9097 14.4392 16.9097 14.5186C16.9097 14.598 16.8926 14.6765 16.8594 14.7494C16.8262 14.8223 16.7775 14.8881 16.7165 14.9428L11.7332 19.4768C11.6722 19.5313 11.6236 19.5971 11.5904 19.67C11.5572 19.7428 11.5401 19.8213 11.5401 19.9006C11.5401 19.9799 11.5572 20.0584 11.5904 20.1313C11.6236 20.2042 11.6722 20.2699 11.7332 20.3245Z" fill="#002961"/>
                                </svg>
                              </div>
                            </category-card>
                          `;
                        })}
                        
                      </div>
                    </div>
                  `
                : html`
                    <div class="slider-result__collections mt-8">
                      
                      <div class="aa-SourceHeader flex justify-between items-center mb-4 ${collectionHits.length > 0 ? '' : 'hidden'}">
                        <span class="aa-SourceHeaderTitle">Ventes</span>
                        ${(() => {
                  
                          if (collectionHits.length > 3) {

                            return html`
                              <a href="/search?shopify_prod_products%5Bquery%5D=${encodeURIComponent(state.query)}" class="aa-SourceHeader__see-more search-collections-redirect-link">
                                Voir tout
                                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M0.233236 11.8245C0.490959 12.0585 0.90777 12.0585 1.16486 11.8245L6.61394 6.86636C6.73592 6.75707 6.83304 6.62553 6.89941 6.47974C6.96578 6.33395 7 6.17695 7 6.0183C7 5.85965 6.96578 5.70266 6.89941 5.55687C6.83304 5.41108 6.73592 5.27954 6.61394 5.17024L1.1254 0.175496C1.00084 0.0638705 0.835881 0.00112939 0.664032 1.50636e-05C0.492182 -0.00109926 0.326326 0.0594968 0.200145 0.169497C0.137637 0.223818 0.0876231 0.28966 0.0531991 0.362944C0.0187752 0.436229 0.000674735 0.515396 1.85384e-05 0.595544C-0.000637658 0.675692 0.0161644 0.755113 0.0493843 0.82889C0.0826042 0.902667 0.131535 0.969229 0.193145 1.02445L5.21651 5.59442C5.27755 5.64907 5.32615 5.71486 5.35937 5.78778C5.39258 5.86071 5.40971 5.93924 5.40971 6.0186C5.40971 6.09796 5.39258 6.1765 5.35937 6.24942C5.32615 6.32234 5.27755 6.38813 5.21651 6.44278L0.233236 10.9768C0.172216 11.0313 0.123623 11.0971 0.090417 11.17C0.0572106 11.2428 0.0400859 11.3213 0.0400859 11.4006C0.0400859 11.4799 0.0572107 11.5584 0.090417 11.6313C0.123623 11.7042 0.172216 11.7699 0.233236 11.8245Z" fill="#002961"/>
                                </svg>
                              </a>
                            `;
                          } else {

                            return '';
                          }
                        })()}
                      </div>
                      ${elements.searchCollections}
                    </div>
                    <div class="search-result">
                      ${elements.searchResults}
                    </div>
                  `
              }
            </div>

          </div>
        </div>
      `;

      //
      // 11) Logique finale "plein écran" vs "no-results" vs "panel classique"
      //
      updateMenuAndClose();
      // ANCIEN COMPORTEMENT COMMENTÉ : affichage du template seeAllBestSellers
      // if (isEmpty && autocompleteMode.showBestSellers150) {
      //   return seeAllBestSellers;     // plein écran 150 best sellers
      // } else 
      // ANCIEN COMPORTEMENT COMMENTÉ : affichage du template seeAllCollections
      // if (isEmpty && autocompleteMode.showCollectionsAll) {
      //   return seeAllCollections;     // plein écran toutes collections
      // } else 
      // if (isEmpty && autocompleteMode.showCategoryCollectionsAll) {
      //   return seeAllcategoryCollections;
      // } else 
      if (isEmpty && autocompleteMode.showCategory) {
        if (elements.categoryResults){
          setTimeout(() => {
            window.initSlickCollectionsCategories();
          }, 0);
          return categoryResults; // plein écran catégorie
        } else {
          setTimeout(() => {
            window.initSlickProductsResults();
            window.initSlickCollectionsResults();
          }, 0);
          
          return noResultsTpl;
        }
      } else if (!isEmpty && autocompleteMode.showSearchCollectionsAll) {
        return seeAllSearchCollections;
      } else if (!isEmpty && isNoResults) {
        // On recharge Slick sur bestSellers/bestCollections si nécessaire
        setTimeout(() => {
          window.initSlickProductsResults();
          window.initSlickCollectionsResults();
        }, 0);
        
        return noResultsTpl;
      } else if (isEmpty){  
        setTimeout(() => {
          // COMMENTÉ : Appel désactivé car frequentSearchesPlugin est commenté
          // window.initSlickFrequentSearches();
          window.initSlickProducts();
          window.initSlickCollections();
        }, 0);
        return panel;
      }
      else {
        setTimeout(() => {
          window.initSlickResultCollections();
        }, 0);
        return panel;
      } 
    }
  );

  // Observer pour détecter l'ajout de nouveaux panels et initialiser Slick en conséquence
  const observer = new MutationObserver(mutations => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches('.slider-search__best-sellers') ||
            node.querySelector('.slider-search__best-sellers')) {
          window.initSlickProducts();
        }
        if (node.matches('.slider-search__collections') ||
            node.querySelector('.slider-search__collections')) {
          window.initSlickCollections();
        }
        if (node.matches('.slider-result__collections') ||
            node.querySelector('.slider-result__collections')) {
          window.initSlickResultCollections();
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  
  
  
  
  
  
  
  


});



